import React, { Component } from 'react';
import {
    Badge,
    Button,
    Card,
    CardBlock,
    CardFooter,
    CardHeader,
    Col,
    Form,
    FormGroup,
    FormText,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";

import ReactTable from 'react-table';
import { CSVLink } from "react-csv";

import * as Constant from '../../../constants/AppConstants';
import axios from 'axios';
import Comments from './Comments';
import VerificationStatus from './VerificationStatus';
import Employed from '../LoanForm/Employed';
import References from './References';
import Business from '../LoanForm/Business';
import 'font-awesome/css/font-awesome.css';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import TimePicker from 'material-ui/TimePicker';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Loader from 'react-loaders';
import { loadProgressBar } from 'axios-progress-bar';

loadProgressBar()
class LoanDetails extends Component {
    constructor(props) {
        super(props);
        this.navigateToLogin = this
            .navigateToLogin
            .bind(this);
        this.logout = this
            .logout
            .bind(this);
        this.toggleLoggedOutModal = this
            .toggleLoggedOutModal
            .bind(this);
        this.verifyAuthToken = this
            .verifyAuthToken
            .bind(this);

        this.initializeState = this
            .initializeState
            .bind(this);
        this.toggleLoader = this
            .toggleLoader
            .bind(this);
        this.handleUserInputperfios = this
            .handleUserInputperfios
            .bind(this);
        this.handleUserInputcheck = this
            .handleUserInputcheck
            .bind(this);
        this.handleUserInput = this
            .handleUserInput
            .bind(this);
        this.handleUserInputDoc = this
            .handleUserInputDoc
            .bind(this);
        this.handleUserInputaccountno = this
            .handleUserInputaccountno
            .bind(this);
        this.handleUserInputifsc = this
            .handleUserInputifsc
            .bind(this);

        this.handleUserInputNameAsPerBank = this
            .handleUserInputNameAsPerBank
            .bind(this);

        this.addComment = this
            .addComment
            .bind(this);
        this.commentcheck = this
            .commentcheck
            .bind(this);
        // this.setInputState              = this
        //     .setInputState
        // .bind(this);
        this.renderStatus = this
            .renderStatus
            .bind(this);
        this.companyclick = this
            .companyclick
            .bind(this);
        //      this.hide_company_list = this.hide_company_list.bind(this);
        this.showcompanylist = this
            .showcompanylist
            .bind(this);
        this.handleAmortChange = this
            .handleAmortChange
            .bind(this);
        this.GetSavedAmort = this
            .GetSavedAmort
            .bind(this);
        this.validatePemanentResidenceType = this
            .validatePemanentResidenceType
            .bind(this);
        this.getAllStates = this
            .getAllStates
            .bind(this);

        this.state = {
            application_id: '',
            selectedBifurcationValue: '',
            finalBifurcayionArray: [],
            bifurcationKey: [{ key: "", value: "" }],
            bifurcationValue: {},
            num: 0,
            bifurcationData: [],
            inputs: ['input-0'],
            bifucation_key: '',
            bifucation_value: [],
            counter: 0,
            dynamicInput: [],
            account_no: '',
            nameasper_bank: '',
            address_type: '',
            amort_approved_amount: '',
            approved_amount: '',
            bank_loan_amount: '',
            bank_loan_rate: '',
            bank_loan_ref_id: '',
            bankLoanAmount: '',
            bankLoanDisbursalDate: '',
            bankLoanRate: '',
            bankRateValid: '',
            bankRefId: '',
            //can_upload_bank_stmt:'',
            canUploadBankStatement: '',
            cap_comment: '',
            capValid: '',
            card_assigned: '',
            card_loaded: '',
            card_registered: '',
            card_status: '',
            change_date: '',
            cheques: '',
            cheques_comment: '',
            chequesValid: '',
            CibilModal: false,
            fossheetModal: false,
            cities: [],
            comment: '',
            comments: [],
            commentValid: '',
            companies: [],
            companyclick: '',
            companyName: '',
            credit_documents_1: [],
            credit_documents_14: [],
            credit_documents_15: [],
            credit_documents_16: [],
            credit_documents_2: [],
            credit_documents_3: [],
            credit_documents_4: [],
            credit_documents_5: [],
            credit_documents_6: [],
            credit_documents_7: [],
            credit_documents_8: [],
            credit_documents_9: [],
            credit_query_comment: '',
            credit_queryValid: '',
            current_address_proof: '',
            //credit_documents_40:[],       other_documents_40:'',
            current_dept: '',
            customer_address: [],
            dateOfBirth: '',
            panNumber: '',
            dcb_form: '',
            dcbformValid: '',
            default_selected: '',
            designation: '',
            designationOther: '',
            designations: [],
            doc_type_comment: '',
            doc_upload_link: '',
            docLinkModal: false,
            document: '',
            documents: {},
            e_bank_statement_link: '',
            education: '',
            educations: [],
            email: '',
            emailModal: false,

            emails: '',
            emailValid: '',
            emi_amount: '',
            emiModal: false,
            employment_types: [],
            experience: '',
            ext_ref_no: '',
            extLoanRefNo: '',
            amort_fields: [],
            amort_schedule_fields: {},

            first_pin_reset: '',
            firstName: '',
            flag: '',
            gender: '',
            genderValid: 'is-valid',
            dateOfBirthValid: 'is-valid',
            highest_education: [],
            id_proof: '',
            idproofValid: '',
            ifsc_code: '',
            incomeMode: '',
            insurance: '',
            insurance_comment: '',
            insuranceValid: '',
            isActiveButton: false,
            landmark: '',
            lastName: '',
            lastNameValid: '',
            latest_pickup: [],
            lead_details: [],
            lead_id: props.match.params.id,
            leadStatus: 'In progress',
            leadStatusColor: 'info',
            links: [],
            loaderActive: false,
            loading: 0,
            loan_agreement: '',
            loan_amount: 0,
            loan_approved: false,
            loan_details: [],
            loan_disbursal_date: '',
            //        loan_reason:'',
            loan_reason: [],
            loan_roi: 4,
            loan_tenure: 0,
            loanagreementValid: '',
            loanAmountValid: '',
            loanreason: '',
            lock_status: '',
            loggedOutModal: false,
            lp_comment: '',
            mail_sent: false,
            mail_unable_to_send: false,
            //       office_address:'',       permanent_address:'',
            mailing_address: '',
            messageModal: false,
            sendPDFModal: false,
            middleName: '',
            mobile: '',
            mobileModal: false,
            mobileValid: '',
            nach_signed: '',
            nachsignedValid: '',
            // new_bank_loan_ref_id    : '',
            new_loan_amount: 0,
            new_loan_tenure: 0,
            new_selectedProduct: '',
            new_serverError: '',
            newLoanModal: false,
            oav_comment: '',
            occupied_since: '',
            occupied_sinceValid: '',
            ofcEmail: '',
            office_email: '',
            ofcEmailModal: false,
            ofcEmailValid: '',
            ofcPhone: '',
            office_phone_number_valid: '',
            office_address: '',
            office_addressValid: '',
            office_city: '',
            office_email: '',
            office_id_card: '',
            office_landmark: '',
            office_phone: '',
            office_pin: '',
            office_pinValid: '',
            office_verification: '',
            officeDetailsUpdated: false,
            officeDetailsUpdateError: false,
            officeidValid: '',
            officeverifyValid: '',
            oid_comment: '',
            other_comment: '',
            other_document_proof: '',
            other_documents: [],
            otherDocumentName: '',
            otherdocumentValid: '',
            otherProfession: '',
            otp_varified: '',
            ownership_type: [],
            panNumber: '',
            panNumberValid: '',
            papValid: '',
            payslips: '',
            payslipsValid: '',
            pendency_comment: '',
            pendency_commentValid: '',
            pending_balance: '',
            perfiosModal: false,
            permanent_address_proof: '',
            permant_address: '',
            photograph: '',
            photographValid: '',
            pickup_addressValid: '',
            pickup_comment: '',
            pickup_commentValid: '',
            pickup_date: '',
            pickup_dateValid: '',
            pickup_time_from: '',
            pickup_time_fromValid: '',
            pickup_time_to: '',
            pickup_time_toValid: '',
            pickupAddressId: [],
            pinCode: '',
            pinValid: '',
            product_code: '',
            product_type: '',
            productTypes: [],
            profession: '',
            professions: [],
            profile_editable: '',
            ref_count: '',
            ref_no: '',
            //        highest_education:'',
            reg_landmark: '',
            resAddress: '',
            resAddress2: '',
            residenceType: '0',
            residenceTypeValid: '',
            salary: '',
            salaryMode: [],
            otherFeesTypes: [],
            salaryModeSelect: '',
            selectCity: '',
            resCityValid: '',
            selectedProduct: '',
            selecteducation: '',
            selectreason: '',
            send_to_dept: 'BE',
            send_toValid: '',
            serverError: '',
            serverMsg: '',
            show_empty_pickup: '',
            showBankDetails: false,
            showcompanyfilter: false,
            spdc_amount: '',
            states: [],
            status_id: '',
            target_for_card: '',
            total_emis: '',

            value12: null,
            workStartYear: '',
            getAmort: false,
            getAmortSchedule: false,
            //xirr sent as a parameter to amort microservice
            xirr: '',
            //xirr sent with loan details api
            check_xirr: 0,
            get_lender_disbursed_amount: '',
            get_approved_amount: null,
            get_roi: null,
            get_first_emi_date: '',
            get_disbursal_date: '',
            get_lender_disbursed_amount_gst: null,
            get_schedule: [],
            get_interest: 0,
            get_principal: 0,
            get_processing_fee: 0,
            get_starting_balance: 0,
            get_closing_balance: 0,
            get_tenure: 0,
            get_lender_spdc: null,
            get_lender_roi: null,
            get_emi_date: null,
            get_gst: null,
            get_emi_amount: null,
            save_amort: '',
            total_principal: 0,
            total_interest: 0,
            field: '',
            amort_request_msg: '',
            total_principal_verify: 0,
            total_principal_verify_response: '',
            total_principal_entered: 0,
            total_interest_entered: 0,
            save_amort_error: '',
            toggleEMIsErrorMsg: '',
            tenure_Valid: '',
            other_Valid: '',
            fed_Valid: '',
            dd_Valid: '',
            approved_amount_Valid: '',
            roi_Valid: '',
            pf_Valid: '',
            show_amort_schedule_after_parameter_change: 1,
            timeouterror: '',
            credit_score: '',
            credit_score_url: '',
            enable_submit: "1",
            office_phone_number_valid: "",
            ResidenceType_valid: "",
            perResAddress: '',
            per_occupied_since: '',
            per_reg_landmark: '',
            perSelectCity: '0',
            perPinCode: '',
            perSelectState: '0',
            permanentAddressValid: '',
            permanentOccupiedSinceValid: '',
            permanentAddressLandmarkValid: '',
            permanentResidencePincodeValid: '',
            permanentCityValid: '',
            permanentStateValid: '',
            perOwnershipType: '',
            perResidenceTypeValid: '',
            ovd_docs: [
                { id: "1", name: "Aadhaar Card" },
                { id: "2", name: "Driving Licence" },
                { id: "3", name: "Passport" },
                { id: "4", name: "Voter ID" },
            ],
            ovd_docs: [
                { id: "1", name: "Aadhaar Card" },
                { id: "2", name: "Driving Licence" },
                { id: "3", name: "Passport" },
                { id: "4", name: "Voter ID" },
            ],
            selectOVD: '0',
            dlValid: 'is-valid',
            voterIDValid: 'is-valid',
            passportValid: 'is-valid',
            passport: '',
            voterIDNumber: '',
            ovd_val: '',
            aadhaar: '',
            dl: '',
            aadhaarValid: 'is-valid',
            allStates: [],
            permanentCities: [],
            ovd_number: '',
            ovdErrorMsg: '',
            formErrorMsg: '',
            select_email: ''




        };
        this.togglePerfiosModal = this
            .togglePerfiosModal
            .bind(this);
        this.toggleDocLinkModal = this
            .toggleDocLinkModal
            .bind(this);
        this.toggleEmailModal = this
            .toggleEmailModal
            .bind(this);
        this.toggleOfcEmailModal = this
            .toggleOfcEmailModal
            .bind(this);
        this.toggleMobileModal = this
            .toggleMobileModal
            .bind(this);
        this.toggleEmiModal = this
            .toggleEmiModal
            .bind(this);
        this.toggleComment = this
            .toggleComment
            .bind(this);
        this.toggleSendPDF = this
            .toggleSendPDF
            .bind(this);
        this.toggleCreateNewLoan = this
            .toggleCreateNewLoan
            .bind(this);
        this.sendPerfios = this
            .sendPerfios
            .bind(this);
        this.sendPDF = this
            .sendPDF
            .bind(this);
        this.sendDocLink = this
            .sendDocLink
            .bind(this);
        this.toggleCibilModal = this
            .toggleCibilModal
            .bind(this);
        this.toggleRegesteredCard = this
            .toggleRegesteredCard
            .bind(this);
        this.toggleNotRegesteredCard = this
            .toggleNotRegesteredCard
            .bind(this);
        this.toggleCardRegistered = this
            .toggleCardRegistered
            .bind(this);
        this.togglependency = this
            .togglependency
            .bind(this);
        this.togglecredit_query = this
            .togglecredit_query
            .bind(this);
        this.changeleadstatus = this
            .changeleadstatus
            .bind(this);
        this.callGetAmort = this
            .callGetAmort
            .bind(this);
        this.callSetAmortApprove = this
            .callSetAmortApprove
            .bind(this);
        this.pendency_resolve = this
            .pendency_resolve
            .bind(this);
        this.credit_query = this
            .credit_query
            .bind(this);
        //      this.toggleAssignedCard = this.toggleAssignedCard.bind(this);
        this.toggleCardNotRegistered = this
            .toggleCardNotRegistered
            .bind(this);
        this.sendEmailVerificationLink = this
            .sendEmailVerificationLink
            .bind(this);
        this.sendMobileVerificationLink = this
            .sendMobileVerificationLink
            .bind(this);
        this.handleUserInputaddresstype = this
            .handleUserInputaddresstype
            .bind(this);
        this.handleUserInputtargetcard = this
            .handleUserInputtargetcard
            .bind(this);
        this.handleUserInputpendency = this
            .handleUserInputpendency
            .bind(this);
        this.handleUserInputcredit = this
            .handleUserInputcredit
            .bind(this);
        this.addpendency = this
            .addpendency
            .bind(this);
        this.addcredit_query = this
            .addcredit_query
            .bind(this);
        // this.changeStatus = this.changeStatus.bind(this);      this.sendOTP =
        // this.sendOTP.bind(this);      this.ResendOTP = this.ResendOTP.bind(this);
        this.refreshPage = this
            .refreshPage
            .bind(this);
        this.getComments = this
            .getComments
            .bind(this);
        this.submitOfficeAddress = this
            .submitOfficeAddress
            .bind(this);
        this.handleAmountSlider = this
            .handleAmountSlider
            .bind(this);
        this.handleeAmountSlider = this
            .handleeAmountSlider
            .bind(this);
        this.handleROISlider = this
            .handleROISlider
            .bind(this);
        this.handleTenureSlider = this
            .handleTenureSlider
            .bind(this);
        this.DisableCopyPaste = this
            .DisableCopyPaste
            .bind(this);
        this.handleeTenureSlider = this
            .handleeTenureSlider
            .bind(this);
        this.addNewLoan = this
            .addNewLoan
            .bind(this);
        this.toggleLoader = this
            .toggleLoader
            .bind(this);
        this.startLoader = this
            .startLoader
            .bind(this);
        this.stopLoader = this
            .stopLoader
            .bind(this);
        this.updateLead = this
            .updateLead
            .bind(this);
        this.sendForCibil = this
            .sendForCibil
            .bind(this);
        this.toggleuploaddocument = this
            .toggleuploaddocument
            .bind(this);
        this.togglefossheet = this
            .togglefossheet
            .bind(this);
        this.addfossheet = this
            .addfossheet
            .bind(this);
        this.fosSheetDetails = this
            .fosSheetDetails
            .bind(this);
        this.submitfossheet = this
            .submitfossheet
            .bind(this);
        this.toggle_loan_revision = this
            .toggle_loan_revision
            .bind(this);
        this.callGetAmort = this.callGetAmort.bind(this);
        this.callSetAmortApprove = this.callSetAmortApprove.bind(this);
        this.setLoanDate = this.setLoanDate.bind(this);


    }

    componentDidMount() {
        this.getAllStates();

        this.getLeadDetails();

        this.getApplicationFormData();
        this.getPermanentResDetails();

        this.setLoanDate();
    }

    initializeState() {
        this.setState(prevState => ({
            amort_approved_amount: '',
            account_no: '',
            bank_loan_amount: '',
            bank_loan_rate: '',
            bank_loan_ref_id: '',
            bankLoanAmount: '',
            bankLoanDisbursalDate: '',
            bankLoanRate: '',
            bankRateValid: '',
            bankRefId: '',
            canUploadBankStatement: '',
            comment: '',
            companies: [],
            companyclick: '',
            companyName: '',
            dateOfBirth: '',
            designation: '',
            designationOther: '',
            email: '',
            emailValid: '',
            experience: '',
            extLoanRefNo: '',
            firstName: '',
            firstNameValid: '',
            gender: '',
            ifsc_code: '',
            incomeMode: '',
            landmark: '',
            lastName: '',
            lastNameValid: '',
            loan_amount: 0,
            loan_roi: 4,
            loan_tenure: 0,
            loanAmountValid: '',
            middleName: '',
            middleNameValid: '',
            mobile: '',
            mobileValid: '',
            new_loan_amount: 0,
            new_loan_tenure: 0,
            occupied_since: '',
            ocuupied_sinceValid: '',
            ofcEmail: '',
            ofcEmailValid: '',
            office_email: '',
            ofcPhone: '',
            office_phone_number_valid: '',
            office_address: '',
            office_addressValid: '',
            office_city: '',
            office_landmark: '',
            office_pin: '',
            office_pinValid: '',
            otherProfession: '',
            panNumber: '',
            panNumberValid: '',
            pinCode: '',
            profession: '',
            profile_editable: '',
            reg_landmark: '',
            resAddress: '',
            residenceType: '0',
            residenceTypeValid: '',
            salary: '',
            salaryModeSelect: '',
            selectCity: '',
            selectedProduct: '',
            selecteducation: '',
            selectreason: '',
            serverError: '',
            showBankDetails: false,
            workStartYear: '',
            amort_dd: '',
            amort_tenure: '',
            amort_fed: '',
            amort_pf: '',
            amort_xirr: '',
            amort_roi: '',
            amort_other: 0,
            approved_amount: '',
            disbursal_date: '',
            first_emi_date: '',
            processing_fee: '',
            roi: '',
            xirr: '',
            tenure: '',
            get_tenure: 0,
            amort_schedule_other_fees: 0,
            get_schedule: [],
            toggleEMIsErrorMsg: '',
            timeouterror: '',

        }));
    }

    getProducts = () => {
        let self = this;
        let querystring = require('querystring');
        let payload = querystring.stringify({ mode: Constant.GET_PRODUCTS_MODE })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({ productTypes: response.data }));
                    self.renderStatus(response.data.loan_status, response.data.lead_status);
                } else {
                    // console.log(response);
                }
            })
            .catch(function (error) {
                // console.log(error);
            });
    }

    getLeadDetails() {
        var self = this;
        var ovd_value = "";
        var querystring = require('querystring');
        var payload = querystring.stringify(
            {
                lead_id: '',
                application_id: self.state.lead_id,
                mode: Constant.GET_LEAD_DETAILS_MODE
            }
        )
        axios({
            data: payload,
            headers: {

                // 'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded',
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    var gender = response.data.gender;
                    if (gender == "m" || gender == "M") {
                        gender = "male";
                    } else if (gender == "f" || gender == "F") {
                        gender = "female";
                    } else {
                        gender = "";
                    }
                    self.setState(prevState => ({
                        account_no: response.data.account_no,
                        bank_loan_ref_id: response.data.extLoanRefNo,
                        canUploadBankStatement: response.data.canUploadBankStatement,
                        companyName: response.data.company_name,
                        dateOfBirth: response.data.dob,
                        designation: response.data.designation_id,
                        doc_upload_link: response.data.doc_upload_link,
                        documents: response.data.documents,
                        e_bank_statement_link: response.data.e_bank_statement_link,
                        email: response.data.email,
                        experience: response.data.experience,
                        // extLoanRefNo          : response.data.extLoanRefNo,
                        firstName: response.data.first_name,
                        gender: gender,
                        ifsc_code: response.data.ifsc_code,
                        incomeMode: response.data.occupation,
                        lastName: response.data.last_name,
                        lead_details: response.data,
                        //productTypes: response.data.products,
                        links: response.data.links,
                        loan_amount: response.data.loan_amount,
                        loan_roi: response.data.loan_rate,
                        loan_approved: response.data.loan_approved,
                        loan_tenure: response.data.loan_tenure,
                        middleName: response.data.middle_name,
                        mobile: response.data.mobile_number,
                        occupied_since: response.data.occupied_since,
                        office_email: response.data.office_email,
                        ofcPhone: response.data.office_phone,
                        office_address_line_1: response.data.office_address,
                        office_address_line_2: response.data.office_address2,
                        office_city: response.data.office_city,
                        office_landmark: response.data.office_landmark,
                        office_pin: response.data.office_pin,
                        other_documents: response.data.other_documents,
                        panNumber: response.data.pan_number,
                        pinCode: response.data.reg_pin,
                        profession: response.data.profession,
                        profile_editable: response.data.profile_editable,
                        reference_count: response.data.reference,
                        virtual_ac_no: response.data.virtual_ac_no,
                        reg_landmark: response.data.reg_landmark,
                        resAddress: response.data.reg_address,
                        resAddress2: response.data.reg_address2,
                        residenceType: response.data.ownership_type_id,
                        salary: response.data.salary,
                        salaryModeSelect: response.data.mode_of_salary,
                        //                can_upload_bank_stmt:response.data.can_upload_bank_stmt,
                        selectCity: response.data.reg_city_id,
                        selecteducation: response.data.highest_education,
                        selectreason: response.data.loan_reason,
                        workStartYear: response.data.work_start_year,
                        check_xirr: response.data.xirr,
                        credit_score_url: response.data.cibil_url,
                        credit_score: response.data.cibil_score,
                        selectOVD: response.data.ovd_id,
                        ovd_val: response.data.ovd_number,
                        nameasper_bank: response.data.nameasper_bank,
                    }));

                    self.renderStatus(
                        response.data.loan_status,
                        response.data.auto_approval_msg,
                        response.data.flag
                    );


                    // console.log(self.state.selectOVD);
                    if (self.state.selectOVD == '1') {
                        self.setState({
                            aadhaar: self.state.ovd_val
                        })


                    }
                    if (self.state.selectOVD == '2') {
                        self.setState({
                            dl: self.state.ovd_val
                        })

                    }
                    if (self.state.selectOVD == '3') {
                        self.setState({
                            passport: self.state.ovd_val
                        })


                    }
                    if (self.state.selectOVD == '4') {

                        self.setState({
                            voterIDNumber: self.state.ovd_val
                        })

                    }


                    console.log(self.state.check_xirr + 'xirr');
                    console.log(self.state.loan_approved + 'approved');

                    if (self.state.check_xirr && self.state.loan_approved) {
                        var form = document.getElementById("form1").setAttribute("disabled", "true");
                    }


                } else if (response.data.error === "Invalid auth token") {
                    self.toggleLoggedOutModal();
                } else if (response.data.error === "Login Expired") {
                    self.toggleLoggedOutModal();
                }

            })
            .catch(function (error) {
            });
    }

    toggleLoggedOutModal() {
        this.setState({
            loggedOutModal: !this.state.loggedOutModal,
            mail_sent: false,
            mail_unable_to_send: false
        })
    }

    navigateToLogin() {
        this.props.history.push('/login');
    }

    logout() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({ mode: Constant.MODE_LOGOUT });
        // console.log("Auth token: " +
        // window.localStorage.getItem(Constant.AUTH_TOKEN));
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            // url: 'https://devapi.stasheasy.com/Admin/services/',
            url: 'https://api.stashfin.com/Admin/services',
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    window.localStorage.setItem(Constant.AUTH_TOKEN, "");
                    window.localStorage.setItem(Constant.TOKEN, "");
                    window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
                    self.navigateToLogin();
                    window.localStorage.setItem(Constant.ORG_ID, "");
                } else {
                    // console.log(response);
                    window.localStorage.setItem(Constant.AUTH_TOKEN, "");
                    window.localStorage.setItem(Constant.TOKEN, "");
                    window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
                    self.navigateToLogin();
                    window.localStorage.setItem(Constant.ORG_ID, "");
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
                window.localStorage.setItem(Constant.AUTH_TOKEN, "");
                window.localStorage.setItem(Constant.TOKEN, "");
                window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
                self.navigateToLogin();
            });

    }

    verifyAuthToken() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
            token: window.localStorage.getItem(Constant.TOKEN),
            mode: Constant.VERIFY_TOKEN_MODE
        })
        axios({
            data: payload,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                // console.log(response);
                if (response.status == 200) {
                    self.getUserDetails();
                } else {
                    self.logout();
                }
            })
            .catch(function (error) {
                self.logout();
            });
    }

    updateLead() {
        var self = this;
        self.setState({
            ovdErrorMsg: ""
        });
        var ovd_no = "";
        if (self.state.residenceType == "0") {

            alert("Please select a residence ownership type");
            return;
        }
        if (self.state.perOwnershipType == "0") {

            alert("Please select a permanent residence ownership type");
            return;
        }

        if (self.state.selectOVD == '1') {

            ovd_no = self.state.aadhaar;

        }
        else if (self.state.selectOVD == '2') {
            ovd_no = self.state.dl;

        }
        else if (self.state.selectOVD == '3') {

            ovd_no = self.state.passport;

        }
        else if (self.state.selectOVD == '4') {
            ovd_no = self.state.voterIDNumber;
        }

        if (ovd_no == "" || ovd_no == null) {
            self.setState({
                ovdErrorMsg: "Kindly enter valid OVD number before submitting "
            });
            return;
        }

        if (this.state.firstNameValid === "is-invalid" ||
            this.state.lastNameValid === "is-invalid" ||
            this.state.genderValid === "is-invalid" ||
            this.state.dateOfBirthValid === "is-invalid" ||
            this.state.emailValid === "is-invalid" ||
            this.state.mobileValid === "is-invalid" ||
            this.state.panValid === "is-invalid" ||
            this.state.ResidenceType_valid === "is-invalid" ||
            this.state.passportValid === "is-invalid" ||
            this.state.aadhaarValid === "is-invalid" ||
            this.state.dlValid === "is-invalid" ||
            this.state.voterIDValid === "is-invalid" ||
            this.state.residenceTypeValid === "is-invalid" ||
            this.state.resValid === "is-invalid" ||
            this.state.reg_landmarkVal === "is-invalid" === "is-invalid" ||
            this.state.pinValid === "is-invalid" ||
            this.state.occupied_sinceValid === "is-invalid" ||
            this.state.residenceTypeValid === "is-invalid" === "is-invalid" ||
            this.state.permanentAddressValid === "is-invalid" ||
            this.state.reg_landmarkValid === "is-invalid" ||
            this.state.permanentStateValid === "is-invalid" ||
            this.state.permanentCityValid === "is-invalid" ||
            this.state.permanentResidencePincodeValid === "is-invalid" ||
            this.state.perResidenceTypeValid === "is-invalid" ||
            this.state.permanentOccupiedSinceValid === "is-invalid" ||
            this.state.office_addressValid === "is-invalid" ||
            this.state.office_landmarkValid === "is-invalid" ||
            this.state.office_pinValid === "is-invalid" ||
            this.state.office_phone_number_valid === "is-invalid" ||
            this.state.account_noValid === "is-invalid" ||
            this.state.ifsc_codeValid === "is-invalid"
        ) {
            self.setState({
                formErrorMsg: "Some field(s) either have an incorrect value or are left blank. Ensure that all fields are filled properly before submitting."
            });

            return;
        }

        self.setPermanentAddressDetails();

        self.setState(prevState => ({ serverError: '', serverMsg: '' }));
        var elem = document.querySelectorAll("#leadupdateform [name]");
        var event = new Event('change');
        var i = 0;
        for (i = 0; i < elem.length; i++) {
            elem[i].dispatchEvent(event);
        }
        var querystring = require('querystring');
        var payload = querystring.stringify({
            account_no: this.state.account_no,
            address_line_1: this.state.resAddress,
            address_line_2: this.state.resAddress2,
            bank_loan_ref_id: this.state.bank_loan_ref_id,
            city: this.state.selectCity,
            company: this.state.companyName,
            dateOfBirth: this.state.dateOfBirth,
            designation_id: this.state.designation,
            email: this.state.email,
            employment_type: this.state.incomeMode,
            experience: this.state.experience,
            first_name: this.state.firstName,
            gender: this.state.gender,
            highest_education: this.state.selecteducation,
            ifsc_code: this.state.ifsc_code,
            landmark: this.state.reg_landmark,
            last_name: this.state.lastName,
            lead_id: this.state.lead_details.lead_id,
            loan_amount: this.state.loan_amount,
            loan_reason: this.state.selectreason,
            loan_roi: this.state.loan_roi,
            loan_tenure: this.state.loan_tenure,
            middle_name: this.state.middleName,
            mobile: this.state.mobile,
            mode: Constant.UPDATE_LEAD,
            occupied_since: this.state.occupied_since,
            office_address_line_1: this.state.office_address_line_1,
            office_address_line_2: this.state.office_address_line_2,
            office_city: this.state.office_city,
            office_email: this.state.office_email,
            office_landmark: this.state.office_landmark,
            office_phone: this.state.ofcPhone,
            office_pin: this.state.office_pin,
            ownership_type: this.state.residenceType,
            pan_number: this.state.panNumber,
            pin: this.state.pinCode,
            profession: this.state.profession,
            salary: this.state.salary,
            salary_mode: this.state.salaryModeSelect,
            work_start_year: this.state.workStartYear,
            ovd_id: this.state.selectOVD,
            ovd_number: ovd_no,
            nameasper_bank: this.state.nameasper_bank,


        });

        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                self.startLoader();
                if (response.status == 200) {

                    self.setState(prevState => ({ serverError: response.data.msg }));
                    location.reload();
                } else {
                    self.stopLoader();
                    self.setState(prevState => ({ serverError: response.data.error }));
                }
            })
            .catch(function (error) {
                self.stopLoader();
                self.setState(prevState => ({ serverError: error.toString() }));
            });
    }

    getApplicationFormData() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({ mode: Constant.GET_APP_FORM_DATA_MODE })
        // console.log("GET_APP_FORM_DATA_MODE: " +
        // window.localStorage.getItem(Constant.AUTH_TOKEN));
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        cities: response.data.cities,
                        designations: response.data.designations,
                        educations: response.data.educations,
                        employment_types: response.data.employment_types,
                        highest_education: response.data.highest_education,
                        loan_reason: response.data.loan_reason,
                        // office_city      : response.data.office_city,
                        // office_pin       : response.data.office_pin,
                        ownership_type: response.data.ownership_type,
                        productTypes: response.data.products,
                        professions: response.data.professions,
                        salaryMode: response.data.salary_modes,
                        states: response.data.states,
                        otherFeesTypes: response.data.otherFeesTypes
                    }));
                } else {
                    // console.log(response);
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
            });
    }

    companyclick(e) {

        var companyname = e.target.textContent;
        this.setState({ companyName: companyname, showcompanyfilter: false });
    }

    addcompanies() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            key: this.state.companyName,
            mode: Constant.COMPANIES
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        }).then(function (response) {
            if (response.status == 200) {
                self.setState(prevState => ({ companies: response.data }));
            }
        }).catch(function (error) {
          });
    }

    handleUserInput(e) {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "companyName") {
            this.showcompanylist();
        }
        this.setState({ [name]: value }, () => {
            this.validateUserInput(name, value);
        });


    }

    validateUserInput(name, value) {

        switch (name) {
            case "firstName":
                if (value.length < 2 || value == "" || value == null || !value.match(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/)) {
                    this.setState({
                        firstNameValid: "is-invalid"

                    });

                }

                else {
                    this.setState({
                        firstNameValid: "is-valid"
                    })
                }

                break;
            case "lastName":
                if (value.length < 2 || value == "" || value == null || !value.match(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/)) {
                    this.setState({
                        lastNameValid: "is-invalid"

                    });

                }

                else {
                    this.setState({
                        lastNameValid: "is-valid"
                    })
                }

                break;
            case "gender":
                if (value == "0" || value == "" || value == null) {
                    this.setState({
                        genderValid: "is-invalid"

                    });

                }

                else {
                    this.setState({
                        genderValid: "is-valid"
                    })
                }

                break;
            case "dateOfBirth":
                if (value == "0" || value == "" || value == null || new Date(value).getFullYear() > (new Date().getFullYear() - 18) || new Date(value) < new Date("1940-01-01")) {
                    this.setState({
                        dateOfBirthValid: "is-invalid"

                    });

                }

                else {
                    this.setState({
                        dateOfBirthValid: "is-valid"
                    })
                }

                break;
            case "email":
                if (value == "" || value == null || !value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    this.setState({
                        emailValid: "is-invalid"

                    });

                }

                else {
                    this.setState({
                        emailValid: "is-valid"
                    })
                }

                break;
            case "mobile":
                if (value == "0" || value == "" || value == null || value.length > 10) {
                    this.setState({
                        mobileValid: "is-invalid"

                    });

                }
                else {
                    this.setState({
                        mobileValid: "is-valid"
                    })
                }

                break;
            case "panNumber":
                if (!value.match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/) || value == "" || value == null) {
                    this.setState({
                        panValid: "is-invalid"

                    });

                }
                else {
                    this.setState({
                        panValid: "is-valid"
                    })
                }

                break;
            case "residenceType":
                if (value != "0" && value != "" && value != null) {
                    this.setState({
                        residenceTypeValid: "is-valid",
                    });
                }
                else {

                    this.setState({
                        residenceTypeValid: "is-invalid",
                    });

                }
                break;

            case "resAddress":
                if (value != "" && !value.match(/^[\s]*$/) && value.length >= 5 && value != null) {
                    this.setState({
                        resValid: "is-valid",
                    });
                }
                else {

                    this.setState({
                        resValid: "is-invalid",
                    });

                }

                break;
            case "selectCity":
                if (value != "0" && value != "" && value != null) {
                    this.setState({
                        resCityValid: "is-valid",
                    });
                }
                else {

                    this.setState({
                        resCityValid: "is-invalid",
                    });

                }
                break;
            case "pinCode":
                if (value != "0" && value != " " && value != "" && value != null && value.length == 6) {
                    this.setState({
                        pinValid: "is-valid",
                    });
                }
                else {

                    this.setState({
                        pinValid: "is-invalid",
                    });

                }
                break;
            case "occupied_since":
                if (value != "0" && value != "" && value != " " && value != null && value.length == 4 && new Date(value).getFullYear() <= (new Date().getFullYear()) && new Date(value).getFullYear() >= (new Date().getFullYear() - 100)) {
                    this.setState({
                        occupied_sinceValid: "is-valid",
                    });
                }
                else {

                    this.setState({
                        occupied_sinceValid: "is-invalid",
                    });

                }
                break;


            case "ofcPhone":
                if (value.match(/^\d{10}$/)) {
                    this.setState({
                        office_phone_number_valid: "",
                    });
                }
                else {

                    this.setState({
                        office_phone_number_valid: "is-invalid",
                    });

                }
                break;



            default:
                break;





        }


    }

    handleEnableSubmit = (e) => {
        this.setState({
            enable_submit: e
        });


    }

    showcompanylist(e) {
        //      console.log(e);
        if (this.state.companyName.length < 3) {
            // console.log("hhh");           setTimeout( "this.hide_company_list" ,5000);
            // setTimeout(function(){return "this.hide_company_list"; }.bind(this), 3000);

        } else {
            this.setState({ companies: [], showcompanyfilter: true });
            this.addcompanies();
        }
    }

    addComment(e) {
        if (this.state.comment === '') {
            this.setState({ commentValid: 'is-invalid' });
        } else {
            this.commentRequest();
        }
    }

    handleAmountSlider(e) {
        const value = e;
        this.setState({ loan_amount: value });
    }

    handleeAmountSlider(e) {
        const value = e;
        this.setState({ new_loan_amount: value });
    }

    handleUserInputDoc(e) {
        var ele = e.target;
        var document_name = ele.getAttribute("name");
        var is_other_doc = 1;
        var doc_type = ele.getAttribute("data-type")
        if (doc_type == "other") {
            document_name = 'Fos Sheet';
            is_other_doc = 1;
        }
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
            ele.value = null;
            alert("Please select document ");
            return false;
        }

        var self = this;

        var payload = new FormData();
        payload.append("mode", Constant.ADD_DOCUMENT);
        payload.append("lead_id", self.state.lead_details.lead_id);
        payload.append("document_name", document_name);
        payload.append("file", files[0], files[0].name);
        payload.append("is_other_doc", is_other_doc);

        if (!confirm(
            "Are you sure to upload file " + files[0].name + " as " + document_name + "?"
        )) {
            ele.value = null;
            return false;
        }
        self.showloading();
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'multipart/form-data'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                self.hideloading();
                // console.log(response);
                ele.value = null;
                if (response.status == 200) {
                    var other_documents = self.state.other_documents;
                    other_documents.push(document_name);
                    self.setState(
                        prevState => ({ other_documents: other_documents, otherDocumentName: '' })
                    );
                    alert("Uploaded : " + response.data.msg);

                } else {
                    self.hideloading();
                    alert("Error : " + response.data.error);
                }
            })
            .catch(function (error) {
                self.hideloading();
                ele.value = null;
                alert("Something went wrong " + error);
                // console.log("Error");
            });

    }

    navigateToLoanDetails() {
        this.props.history.push('/Login');
    }


    handleROISlider(e) {
        const value = e;
        this.setState({ loan_roi: value });
    }

    handleTenureSlider(e) {
        const value = e;
        this.setState({ loan_tenure: value });
    }

    handleeTenureSlider(e) {
        const value = e;
        this.setState({ new_loan_tenure: value });
    }

    addNewLoan() {
        if (this.state.selectedProduct === '') {
            // console.log('Form invalid')
            this.setState({ new_serverError: 'Product type not selected' })
        } else {
            // console.log('Form valid')
            this.setState({ new_serverError: '' })
            this.toggleLoader();
            this.createLoan();
        }
    }

    createLoan() {
        this.setState(
            { loan_amount: this.state.new_loan_amount, loan_tenure: this.state.new_loan_tenure }
        );
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            bank_id: self.state.bank_id,
            bank_loan_amount: self.state.bank_loan_amount,
            bank_loan_rate: self.state.bank_loan_rate,
            bank_loan_tenure: self.state.bank_loan_tenure,
            existing_lead_id: self.state.lead_details.lead_id,
            loan_amount: self.state.loan_amount,
            loan_roi: self.state.loan_roi,
            loan_tenure: self.state.loan_tenure,
            mode: Constant.CREATE_LOAN,
            product_code: self.state.selectedProduct,
            product_type: self.state.selectedProduct
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                // console.log(response);
                if (response.status == 200) {
                    // console.log(response);
                    self.toggleLoader();
                    self.toggleCreateNewLoan();

                } else {
                    // console.log(response);
                    self.toggleLoader();
                    self.setState(prevState => ({ serverError: response.data.error }));
                }
            })
            .catch(function (error) {
                self.setState(prevState => ({ serverError: error }));
                // console.log(error);
            });
    }

    commentRequest() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            comment: self.state.comment,
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.ADD_COMMENT
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        }).then(function (response) {
            if (response.status == 200) {
                self.setState({ comment: '', commentAdded: true });
                self.getComments();
                self.toggleComment();
            }
        }).catch(function (error) {
            // console.log("Error"); console.log(error);
        });
    }

    getComments() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: '',
            application_id: self.state.lead_id,
            mode: Constant.GET_COMMENTS_MODE
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    if (response.data.length > 0) {
                        self.setState(prevState => ({ comments: response.data }));
                    } else {
                        self.setState(prevState => ({ comments: [] }));
                    }
                } else {
                    // console.log(response);
                }
            })
            .catch(function (error) {
                // console.log(error);
            });
    }

    startLoader() {
        this.setState({ loaderActive: true })
    }
    stopLoader() {
        this.setState({ loaderActive: false })
    }

    renderStatus(as, ls) {
        switch (as) {
            case "Disbursed":
                this.setState({ appStatus: as, statusColor: 'success' });
                break;
            case "Incomplete Application":
                this.setState({ appStatus: as, statusColor: 'warning' });
                break;
            case 'Under Processing':
                this.setState({ appStatus: as, statusColor: 'warning' });
                break;
            case 'Approved':
                this.setState({ appStatus: as, statusColor: 'success' });
                break;
            case 'Rejected':
                this.setState({ appStatus: as, statusColor: 'danger' });
                break;
            case 'closed':
                this.setState({ appStatus: as, statusColor: 'secondary' });
                break;
            case 'Pre-approved':
                this.setState({ appStatus: as, statusColor: 'info' });
                break;
            default:
                this.setState({ appStatus: as, statusColor: 'secondary' });
                break;
        }
        this.setState({ leadStatus: ls, leadStatusColor: 'info' });
    }

    sendPerfios() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mail_to: self.state.emails,
            mode: Constant.SEND_PERFIOS_MODE
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({ mail_sent: true }));
                } else {
                    // console.log(response);
                    self.setState(
                        prevState => ({ errorMsg: response.data.error, mail_unable_to_send: true })
                    );
                }
            })
            .catch(function (error) {
                // console.log(error);
                self.setState(
                    prevState => ({ errorMsg: "Server error", mail_unable_to_send: true })
                );
            });
    }

    sendPDF() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            email_type: self.state.select_email,
            mode: Constant.SEND_PDF_MODE
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        }).then(function (response) {
            if (response.status == 200) {
                // console.log(response);
                self.setState(prevState => ({ mail_sent: true }));
            } else {
                // console.log(response);
                self.setState(
                    prevState => ({ errorMsg: response.data.error, mail_unable_to_send: true })
                );
            }
        })
            .catch(function (error) {
                // console.log(error);
                self.setState(
                    prevState => ({ errorMsg: "Server error", mail_unable_to_send: true })
                );
            });
    }

    sendDocLink() {
        var self = this;
        self.toggleLoader();
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mail_to: self.state.emails,
            mode: Constant.SEND_DOCLINK_MODE
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                self.toggleLoader();
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({ mail_sent: true }));
                } else {
                    // console.log(response);
                    self.setState(
                        prevState => ({ errorMsg: response.data.error, mail_unable_to_send: true })
                    );
                }
            })
            .catch(function (error) {
                getamort_sub
                // console.log(error);
                self.setState(
                    prevState => ({ errorMsg: "Server error", mail_unable_to_send: true })
                );
            });
    }

    sendForCibil() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.SEND_CIBIL_VERIFICATION_MODE
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({ mail_sent: true }));
                } else {
                    // console.log(response);
                    self.setState(
                        prevState => ({ errorMsg: response.data.error, mail_unable_to_send: true })
                    );
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
                self.setState(
                    prevState => ({ errorMsg: "Server error", mail_unable_to_send: true })
                );
            });
    }

    sendEmailVerificationLink() {
        var self = this;
        self.toggleLoader();
        var querystring = require('querystring');
        var payload = querystring.stringify({
            email_type: self.state.email_type,
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.SEND_EMAIL_VERIFICATION_MODE
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                self.toggleLoader();
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({ mail_sent: true }));
                } else {
                    // console.log(response);
                    self.setState(
                        prevState => ({ errorMsg: response.data.error, mail_unable_to_send: true })
                    );
                }
            })
            .catch(function (error) {
                // console.log(error);
                self.setState(
                    prevState => ({ errorMsg: "Server error", mail_unable_to_send: true })
                );
            });
    }

    sendMobileVerificationLink() {
        var self = this;
        self.toggleLoader();
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.SEND_MOBILE_VERIFICATION_MODE
        });
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                self.toggleLoader();
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({ mail_sent: true }));
                } else {
                    // console.log(response);
                    self.setState(
                        prevState => ({ errorMsg: response.data.error, mail_unable_to_send: true })
                    );
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
                self.setState(
                    prevState => ({ errorMsg: "Server error", mail_unable_to_send: true })
                );
            });
    }

    togglePerfiosModal() {
        // console.log("togglePerfiosModal");
        this.setState({
            mail_sent: false,
            mail_unable_to_send: false,
            perfiosModal: !this.state.perfiosModal
        })
    }

    toggleDocLinkModal() {
        // console.log("toggleDocLinkModal");
        this.setState({
            docLinkModal: !this.state.docLinkModal,
            mail_sent: false,
            mail_unable_to_send: false
        })
    }

    toggleCibilModal() {
        this.setState({
            CibilModal: !this.state.CibilModal,
            mail_sent: false,
            mail_unable_to_send: false
        })
    }

    toggleEmailModal() {
        this.setState({
            email_type: "personal",
            emailModal: !this.state.emailModal,
            mail_sent: false,
            mail_unable_to_send: false
        })
    }

    toggleOfcEmailModal() {
        this.setState({
            email_type: "professional",
            mail_sent: false,
            mail_unable_to_send: false,
            ofcEmailModal: !this.state.ofcEmailModal
        })
    }

    toggleMobileModal() {
        this.setState({
            mail_sent: false,
            mail_unable_to_send: false,
            mobileModal: !this.state.mobileModal
        })
    }

    toggleComment() {
        this.setState({
            messageModal: !this.state.messageModal
        })
    }

    toggleSendPDF() {
        this.setState({
            sendPDFModal: !this.state.sendPDFModal
        })
    }

    toggleCreateNewLoan() {
        this.setState({
            newLoanModal: !this.state.newLoanModal
        })
    }

    toggleRegesteredCard() {
        this.setState({
            cardRegisteredModal: !this.state.cardRegisteredModal
        })
    }

    toggleNotRegesteredCard() {

        this.setState({
            cardNotRegisteredModal: !this.state.cardNotRegisteredModal
        })

    }

    toggleCardNotRegistered() {
        var self = this;
        var cardForm = document.getElementById("cardform");
        var payload = new FormData(cardForm);

        //   console.log(checked);

        var querystring = require('querystring');
        var payload = querystring.stringify({
            address_type: self.state.address_type,
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.CARD_NOT_REGISTER,
            target_for_card: self.state.target_for_card
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {

                    self.setState({ target: '', targetAdded: true });
                    self.setState({ target_for_card: 'yes' });
                    self.setState(prevState => ({

                    }));
                    window.location.reload();

                } else {
                    self.setState(prevState => ({
                        errorMsg: response.data.error
                    }));
                }

            })
            .catch(function (error) {
            });
    }


    handleUserInputaddresstype(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
    }

    handleUserInputtargetcard(e) {
        var checked = document
            .getElementById("cardCheck")
            .checked;
        if (checked == true) {
            checked = 'yes';
        } else {
            checked = 'no';
        }

        const name = e.target.name;
        const value = e.target.value;
        this.setState({ target_for_card: checked });

    }

    toggleCardRegistered() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.GET_CARD_DETAILS
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {

                    //
                    self.setState(prevState => ({
                        card_assigned: response.data.card_assigned,
                        card_loaded: response.data.card_loaded,
                        card_registered: response.data.card_registered,
                        cardRegisteredModal: !prevState.cardRegisteredModal,
                        first_pin_reset: response.data.first_pin_reset,
                        lock_status: response.data.lock_status,
                        otp_varified: response.data.otp_varified,
                        pending_balance: response.data.pending_balance,
                        target_for_card: response.data.target_for_card
                    }));
                }
                //                  }

            })
            .catch(function (error) {
                // console.log(error);
            });
    }

    toggleEmiModal() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.GET_AMORTIZATION_SCHEDULE
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        emiModal: !prevState.emiModal,
                        emis: response.data.emis,
                        loan_details: response.data.loan_details,

                        loan_disbursal_date: (
                            response.data.loan_details.loan_disbursal_date != null
                                ? (response.data.loan_details.loan_disbursal_date).substr(0, 10)
                                : ''
                        ),
                        total_emis: response.data.emis.length
                    }));
                } else {

                    self.setState({ toggleEMIsErrorMsg: response.data.error });
                }
            })
            .catch(function (error) {
                self.setState(
                    prevState => ({
                        errorMsg: "Server error", mail_unable_to_send: true,
                        toggleEMIsErrorMsg: response.data.error
                    })
                );
            });
    }

    submitOfficeAddress() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.SUBMIT_OFFICE_DETAIL_MODE,
            office_address: self.state.office_address,
            office_city: self.state.office_city,
            office_email: self.state.office_email,
            office_phone: self.state.office_phone,
            office_pin: self.state.office_pin
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {

                if (response.status == 200) {
                    // console.log(response);
                    self.setState(
                        prevState => ({ officeDetailsUpdated: true, officeDetailsUpdateError: false })
                    );
                } else {
                    // console.log(response);
                    self.setState(
                        prevState => ({ officeDetailsUpdated: false, officeDetailsUpdateError: true })
                    );
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
                self.setState(
                    prevState => ({ officeDetailsUpdated: false, officeDetailsUpdateError: true })
                );
            });
    }

    // myFunction() { var text = document.getElementsByClassName('js-text');
    // text[0].select();  document.execCommand("Copy");  }

    toggle_loan_revision() {
        this.setState({
            loanRevisionModal: !this.state.loanRevisionModal
        })
    }

    toggleuploaddocument() {
        this.setState({
            uploaddocumentModal: !this.state.uploaddocumentModal
        })
    }

    showloading() {
        var loadingcount = this.state.loading++;
        this.setState({ loading: loadingcount });
    }

    hideloading() {
        var loadingcount = this.state.loading--;
        this.setState({ loading: loadingcount });
    }

    handleUserInputcheck() {
        this.toggleLoader();
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.RECHECK_APPROVAL_STATUS
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                self.toggleLoader();
                if (response.status == 200) {
                    // console.log(response);
                    if (response.data.msg == "") {
                        alert(response.data.msg);
                    }
                    //self.navigateToDashboard();
                    self.refreshPage();
                } else {
                    // console.log(response);
                    self.setState(prevState => ({ serverError: response.data.error }));
                }
            })
            .catch(function (error) {
                self.toggleLoader();
                self.setState(prevState => ({ serverError: error }));
                // console.log(error);
            });
    }

    refreshPage() {
        window
            .location
            .reload()
    }

    toggleLoader() {
        this.setState({
            loaderActive: !this.state.loaderActive
        })
    }

    handleUserInputperfios() {
        var self = this;
        var checked = document
            .getElementById("myCheck")
            .checked;
        //   console.log(checked);
        if (checked == true) {
            checked = 1;
        } else {
            checked = 0;
        }
        //   console.log(checked);
        self.setState({ canUploadBankStatement: checked });

        // console.log("hell");
        var querystring = require('querystring');
        var payload = querystring.stringify({
            can_upload_bank_stmt: checked,
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.ALLOWBANKSTATEMENT
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({ canUploadBankStatement: checked }));
                } else {
                    // console.log(response);
                    if (checked == 1) {
                        checked = 0;
                    } else {
                        checked = 1;
                    }

                    self.setState(
                        prevState => ({ canUploadBankStatement: checked, errorMsg: response.data.error })
                    );
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
                self.setState(
                    prevState => ({ errorMsg: "Server error", mail_unable_to_send: true })
                );
            });
    }

    handleUserInputaccountno(e) {
        //      str = str.replace(/\d(?=\d{4})/g, "*");
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value
        }, () => {
            this.validateaccountno(name, value)
        });
    }

    validateaccountno(fieldName, value) {
        switch (fieldName) {
            case 'account_no':

                if (value.match(/[a-zA-Z "!?.-]+$/)) {
                    this.setState({ account_noValid: 'is-invalid' });

                } else if (value.length < 9) {
                    this.setState({ account_noValid: 'is-invalid' });

                } else if (value.length > 18) {
                    this.setState({ account_noValid: 'is-invalid' });

                } else {
                    this.setState({ account_noValid: 'is-valid' });
                }
                break;
            default:
                break;
        }
    }

    handleUserInputifsc(e) {
        //      str = str.replace(/\d(?=\d{4})/g, "*");
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value
        }, () => {
            this.validateifsc(name, value)
        });
    }

    handleUserInputNameAsPerBank(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value
        });
    }

    validateifsc(value) {
        var valid = true;
        if (this.state.ifsc_code.length < 11) {
            this.setState({ ifsc_codeValid: 'is-invalid' });
            valid = false;
        } else if (this.state.ifsc_code.length > 11) {
            this.setState({ ifsc_codeValid: 'is-invalid' });
            valid = false;
        } else if (value.match(!/[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/)) {
            this.setState({ ifsc_codeValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ ifsc_codeValid: 'is-valid' });
        }

        return valid;
    }

    handleDocChange(e) {
        var ele = e.target;
        var document_name = ele.getAttribute("name");
        var is_other_doc = 0;
        var doc_type = ele.getAttribute("data-type")
        if (doc_type == "other") {
            document_name = this.state.otherDocumentName;
            is_other_doc = 1;
        }
        document_name = document_name.trim();
        if (document_name == "") {
            ele.value = null;
            alert("Please enter document name");
            return false;
        }
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
            ele.value = null;
            alert("Please select document ");
            return false;
        }

        //   console.log(ele.value);
        var self = this;

        var payload = new FormData();
        payload.append("mode", Constant.ADD_DOCUMENT);
        payload.append("lead_id", self.state.lead_details.lead_id);
        payload.append("document_name", document_name);
        payload.append("file", files[0], files[0].name);
        payload.append("is_other_doc", is_other_doc);

        if (!confirm(
            "Are you sure to upload file " + files[0].name + " as " + document_name + "?"
        )) {
            ele.value = null;
            return false;
        }
        self.showloading();
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'multipart/form-data'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                self.hideloading();
                // console.log(response);
                ele.value = null;
                if (response.status == 200) {
                    if (is_other_doc == 0) {
                        var documents = self.state.documents;
                        documents[document_name] = true;
                        self.setState(prevState => ({ documents: documents }));
                        // window
                        //     .location
                        //     .reload();

                    } else {
                        var other_documents = self.state.other_documents;
                        // other_documents.push(document_name); self.setState(prevState => ({
                        // other_documents:other_documents,     otherDocumentName:''   }));
                    }
                    alert("Uploaded : " + response.data.msg);
                    // window
                    //     .location
                    //     .reload();
                    // window
                    //     .location
                    //     .reload();

                } else {
                    self.hideloading();
                    alert("Error : " + response.data.error);
                }
            })
            .catch(function (error) {
                self.hideloading();
                ele.value = null;
                alert("Something went wrong " + error);
                // console.log("Error");
            });
    }

    //getLocation(){    return AsyncStorage.getItem('userData_key') }

    // setInputState(event) {
    //     this.setState({bank_loan_ref_id: event.target.value});
    // }

    DisableCopyPaste(event) {
        // Message to display var message = "Cntrl key/ Right Click Option disabled";
        // check mouse right click or Ctrl key press
        var kCode = event.keyCode || event.charCode;
        //FF and Safari use e.charCode, while IE use e.keyCode
        if (kCode == 17 || kCode == 2) {

            return false;
        }
    }

    mypassword() {
        var x = document.getElementById("passwordfield");
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    togglefossheet() {
        this.setState({
            fossheetModal: !this.state.fossheetModal
        });
    }

    handleUserInputfossheet(e) {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            [name]: value
        }, function () {

            //        this.validatefossheet();
        });
    }

    handleUserInputpendency(e) {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            comment: value,
            status_id: 77
        }, function () {

            //        this.validatefossheet();
        });
    }

    handleUserInputcredit(e) {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            comment: value,
            status_id: 51
        }, function () {

            //        this.validatefossheet();
        });
    }


    addfossheet(e) {
        var valid = this.validatefossheet();
        if (valid === true) {
            this.submitfossheet();
        }
    }


    validatefossheet() {
        var valid = true;
        // var pickup_time_from =
        // document.getElementsByName('pickup_time_from')[0].value;    var
        // pickup_time_to = document.getElementsByName('pickup_time_to')[0].value;
        if (this.state.pickup_date == '') {
            this.setState({ pickup_dateValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ pickup_dateValid: 'is-valid' });
        }

        if (this.state.pickup_time_from == '') {
            this.setState({ pickup_time_fromValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ pickup_time_fromValid: 'is-valid' });
        }

        if (this.state.pickup_time_to == '') {
            this.setState({ pickup_time_fromValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ pickup_time_fromValid: 'is-valid' });
        }

        if (this.state.pickup_time_to == '') {
            this.setState({ pickup_time_toValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ pickup_time_toValid: 'is-valid' });
        }

        if (this.state.pickupAddressId == '') {
            this.setState({ pickup_addressValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ pickup_addressValid: 'is-valid' });
        }

        if (this.state.permanent_address_proof == '') {
            this.setState({ papValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ papValid: 'is-valid' });
        }

        if (this.state.current_address_proof == '') {
            this.setState({ capValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ capValid: 'is-valid' });
        }

        if (this.state.id_proof == '') {
            this.setState({ idproofValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ idproofValid: 'is-valid' });
        }

        if (this.state.payslips == '') {
            this.setState({ payslipsValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ payslipsValid: 'is-valid' });
        }

        if (this.state.cheques == '') {
            this.setState({ chequesValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ chequesValid: 'is-valid' });
        }

        if (this.state.loan_agreement == '') {
            this.setState({ loanagreementValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ loanagreementValid: 'is-valid' });
        }

        if (this.state.nach_signed == '') {
            this.setState({ nachsignedValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ nachsignedValid: 'is-valid' });
        }

        if (this.state.office_verification == '') {
            this.setState({ officeverifyValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ officeverifyValid: 'is-valid' });
        }

        if (this.state.photograph == '') {
            this.setState({ photographValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ photographValid: 'is-valid' });
        }

        if (this.state.office_id_card == '') {
            this.setState({ officeidValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ officeidValid: 'is-valid' });
        }

        if (this.state.dcb_form == '') {
            this.setState({ dcbformValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ dcbformValid: 'is-valid' });
        }

        if (this.state.insurance == '') {
            this.setState({ insuranceValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ insuranceValid: 'is-valid' });
        }

        if (this.state.other_document_proof == '') {
            this.setState({ otherdocumentValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ otherdocumentValid: 'is-valid' });
        }

        if (this.state.send_to_dept == '') {
            this.setState({ send_toValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ send_toValid: 'is-valid' });
        }

        if (this.state.pickup_comment == '') {
            this.setState({ pickup_commentValid: 'is-invalid' });
            valid = false;
        } else {
            this.setState({ pickup_commentValid: 'is-valid' });
        }

        return valid;
    }


    submitfossheet(e) {
        var self = this;
        var fosForm = document.getElementById("fossheetform");

        var pickup_date = document
            .getElementsByName('pickup_date')[0]
            .value;
        if (pickup_date == '') {
            alert("Please Fill the Pickup Date");

            return false;
        }
        var pickup_time_from = document
            .getElementsByName('pickup_time_from')[0]
            .value;
        if (pickup_time_from == '') {
            alert("Please Fill the Pickup Time From");
            return false;
        } else { }
        var pickup_time_to = document
            .getElementsByName('pickup_time_to')[0]
            .value;
        if (pickup_time_to == '') {
            alert("Please Fill the Pickup Time To");
            return false;
        } else { }

        if (pickup_time_to < pickup_time_from) {
            alert("Pickup Time From cannot be greater than Pickup Time To ");
            return false;
        } else if (pickup_time_to == pickup_time_from) {
            alert("Pickup Time From cannot be equal to Pickup Time To ");
            return false;
        }

        var pickup_comment = document
            .getElementsByName('pickup_comment')[0]
            .value;
        if (pickup_comment == '') {
            alert("Please insert some comment");
            return false;
        }

        var documents = [];
        var elementList = document.getElementsByClassName('document_row');
        self.state.documents = {};
        for (var i = 0; i < elementList.length; i++) {
            var docu = {};
            var child = elementList[i].getElementsByClassName('select_option');
            var docs = [];
            docs.push(child[0].options[child[0].selectedIndex].value);

            var doc_id = child[0].getAttribute('id');
            if (i == 1 || i == 3 || i == 4 || i == 7 || i == 9 || i == 11) {
                var doc_type_comment = document
                    .getElementsByClassName('document_row')[i]
                    .getElementsByClassName('doc_comment')[0]
                    .value;
            }
            var is_fos_doc = "";
            docu.doc_id = doc_id;
            docu.is_fos_doc = is_fos_doc;
            docu.doc_type_comment = doc_type_comment;
            docu.docs = docs;

            self
                .state
                .documents[i] = docu;
        }

        var payload = new FormData(fosForm);
        var finalDocuments = JSON.stringify(self.state.documents);
        payload.append("mode", Constant.SUBMIT_FOS_SHEET);
        payload.append("lead_id", self.state.lead_details.lead_id);
        payload.append("pickupAddressId", self.state.pickupAddressId);
        payload.append("pickup_date", self.state.pickup_date);
        payload.append("pickup_time_from", pickup_time_from);
        payload.append("pickup_time_to", pickup_time_to);
        payload.append("pickup_comment", self.state.pickup_comment);
        payload.append("send_to_dept", self.state.send_to_dept);
        payload.append("documents", finalDocuments);

        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    self.setState(prevState => ({
                        fossheetModal: !prevState.fossheetModal,
                        pickup: '',
                        pickupAdded: true,
                        serverError: response.data.msg
                    }));

                    alert('Pickup Created Successfully');
                    window
                        .location
                        .reload();

                } else {
                    // console.log(response);
                    self.setState(prevState => ({ serverError: response.data.error }));

                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
            });
    }


    navigateToDashboard() {
        this
            .props
            .history
            .push('/loanDetails:id');
    }


    fosSheetDetails() {
        var self = this;
        // console.log("test");
        var querystring = require('querystring');
        var payload = querystring.stringify({
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.GET_FOS_SHEET_DETAILS
        });
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({

                        fossheetModal: !prevState.fossheetModal,
                        latest_pickup: response.data.latest_pickup,

                        approved_amount: response.data.approved_amount,
                        cheques: response.data.cheques,
                        credit_documents_1: response.data.credit_documents_1,
                        credit_documents_14: response.data.credit_documents_14,
                        credit_documents_15: response.data.credit_documents_15,
                        credit_documents_16: response.data.credit_documents_16,
                        credit_documents_2: response.data.credit_documents_2,
                        credit_documents_3: response.data.credit_documents_3,
                        credit_documents_4: response.data.credit_documents_4,
                        credit_documents_5: response.data.credit_documents_5,
                        credit_documents_6: response.data.credit_documents_6,
                        credit_documents_7: response.data.credit_documents_7,
                        credit_documents_8: response.data.credit_documents_8,
                        credit_documents_9: response.data.credit_documents_9,
                        current_address_proof: response.data.current_address_proof,
                        customer_address: response.data.customer_address,
                        dcb_form: response.data.dcb_from,
                        emi_amount: response.data.emi_amount,
                        id_proof: response.data.id_proof,
                        insurance: response.data.insurance,
                        loan_agreement: response.data.loan_agreement,
                        nach_signed: response.data.nach_signed,
                        office_id_card: response.data.office_id_card,
                        office_verification: response.data.office_verification,
                        payslips: response.data.payslips,
                        permanent_address_proof: response.data.permanent_address_proof,
                        photograph: response.data.photograph,
                        pickupAddressId: response.data.pickupAddressId,
                        show_empty_pickup: response.data.show_empty_pickup,
                        spdc_amount: response.data.spdc_amount
                    }));
                } else {
                }
            })
            .catch(function (error) {
                console.log("error in fosheetdetails");
            });
    }


    pendency_resolve() {

        var first_name = document
            .getElementById('first-name')
            .value;
        var last_name = document
            .getElementById('last-name')
            .value;
        var email = document
            .getElementById('email')
            .value;
        var gender = document
            .getElementById('gender')
            .value;
        var date_of_birth = document
            .getElementById('date-of-birth')
            .value;
        var pan_number = document
            .getElementById('pan-number')
            .value;
        var mobile_number = document
            .getElementById('mobile-number')
            .value;
        var residence_type = document
            .getElementById('residence-type')
            .value;
        var residential_address = document
            .getElementById('residential-address')
            .value;
        var home_city = document
            .getElementById('home-city')
            .value;
        var home_pincode = document
            .getElementById('home-pincode')
            .value;
        var occupied_since = document
            .getElementById('occupied-since')
            .value;
        var permanent_residential_address = document
            .getElementById('permanent-residential-address')
            .value;
        var permanent_home_city = document
            .getElementById('permanent-home-city')
            .value;
        var permanent_home_pincode = document
            .getElementById('permanent-home-pincode')
            .value;
        var permanent_occupied_since = document
            .getElementById('permanent-occupied-since')
            .value;
        //        var reg_landmark = document.getElementById('reg_landmark').value;
        var employment = document
            .getElementById('employment')
            .value;
        // var official_email = document
        //     .getElementById('official-email')
        //     .value;
        var official_phone = document
            .getElementById('official-phone')
            .value;
        var official_address = document
            .getElementById('office-address')
            .value;
        var office_city = document
            .getElementById('office-city')
            .value;
        var office_pin = document
            .getElementById('office-pin')
            .value;
        if (first_name == '') {
            alert("First Name field is pending");
        } else if (last_name == '') {
            alert("Last Name field is pending");
        } else if (email == '') {
            alert("Email field is pending");
        } else if (gender == '') {
            alert("Gender field is pending");
        } else if (date_of_birth == '') {
            alert("Date of birth field is pending");
        } else if (pan_number == '') {
            alert("Pan Number field is pending");
        } else if (this.state.selectOVD == '0') {
            alert("Please select the OVD field");
        } else if (this.state.aadhaarValid == "is-invalid" ||
            this.state.passportValid == "is-invalid" ||
            this.state.dlValid == "is-invalid" ||
            this.state.voterIDValid == "is-invalid") {
            alert("OVD ID field is pending");
        } else if (mobile_number == '') {
            alert("Mobile Number field is pending");
        } else if (residence_type == 0) {
            alert("Residence Type field is pending");
        } else if (residential_address == '') {
            alert("Residential Address field is pending");
        } else if (home_city == 0) {
            alert("City field is pending");
        } else if (home_pincode == '') {
            alert("Pincode field is pending");
        } else if (occupied_since == '') {
            alert("Occupied Since field is pending");
        } else if (permanent_residential_address == '') {
            alert("Permanent Residential Address field is pending");
        } else if (permanent_home_city == 0) {
            alert("Permanent Residence City field is pending");
        } else if (permanent_home_pincode == '') {
            alert("Permanent Address Pincode field is pending");
        } else if (permanent_occupied_since == '') {
            alert("Permanent Residence Occupied Since field is pending");
        } else if (employment == '') {
            alert("Employment Type field is pending");
        } else if (official_phone == '') {
            alert("Official Phone field is pending");
        } else if (official_address == '') {
            alert("Official Address field is pending");
        } else if (office_city == 0) {
            alert("Office City field is pending");
        } else if (office_pin == '') {
            alert("Office Pin field is pending");
        } else if (this.state.links.cibil == true) {
            alert("Bureau Status is pending");
        } else if (this.state.links.mobile == true) {
            alert("Mobile Verification is pending");
        } else if (this.state.links.perfios == true) {
            alert("Banking is pending");
        } else if (this.state.links.persional_email == true) {
            alert("Personal Email Verification is pending");
        } else if (this.state.links.docs_upload == false) {
            alert("Document Uploaded is pending");
        } else {
            this.togglependency();
        }

    }


    togglependency() {
        this.setState({
            pendencyModal: !this.state.pendencyModal
        })
    }


    credit_query() {
        var first_name = document
            .getElementById('first-name')
            .value;
        var last_name = document
            .getElementById('last-name')
            .value;
        var email = document
            .getElementById('email')
            .value;
        var gender = document
            .getElementById('gender')
            .value;
        var date_of_birth = document
            .getElementById('date-of-birth')
            .value;
        var pan_number = document
            .getElementById('pan-number')
            .value;
        var mobile_number = document
            .getElementById('mobile-number')
            .value;
        var residence_type = document
            .getElementById('residence-type')
            .value;
        var residential_address = document
            .getElementById('residential-address')
            .value;
        var home_city = document
            .getElementById('home-city')
            .value;
        var home_pincode = document
            .getElementById('home-pincode')
            .value;
        var occupied_since = document
            .getElementById('occupied-since')
            .value;
        var permanent_residential_address = document
            .getElementById('permanent-residential-address')
            .value;
        var permanent_home_city = document
            .getElementById('permanent-home-city')
            .value;
        var permanent_home_pincode = document
            .getElementById('permanent-home-pincode')
            .value;
        var permanent_occupied_since = document
            .getElementById('permanent-occupied-since')
            .value;
        //        var reg_landmark = document.getElementById('reg_landmark').value;
        var employment = document
            .getElementById('employment')
            .value;
        // var official_email = document
        //     .getElementById('official-email')
        //     .value;
        var official_phone = document
            .getElementById('official-phone')
            .value;
        var official_address = document
            .getElementById('office-address')
            .value;
        var office_city = document
            .getElementById('office-city')
            .value;
        var office_pin = document
            .getElementById('office-pin')
            .value;
        if (first_name == '') {
            alert("First Name field is pending");
        } else if (last_name == '') {
            alert("Last Name field is pending");
        } else if (email == '') {
            alert("Email field is pending");
        } else if (gender == '') {
            alert("Gender field is pending");
        } else if (date_of_birth == '') {
            alert("Date of birth field is pending");
        } else if (pan_number == '') {
            alert("Pan Number field is pending");
        } else if (this.state.selectOVD == '0') {
            alert("Please select the OVD field");
        } else if (this.state.aadhaarValid == "is-invalid" ||
            this.state.passportValid == "is-invalid" ||
            this.state.dlValid == "is-invalid" ||
            this.state.voterIDValid == "is-invalid") {
            alert("OVD ID field is pending");
        } else if (mobile_number == '') {
            alert("Mobile Number field is pending");
        } else if (residence_type == 0) {
            alert("Residence Type field is pending");
        } else if (residential_address == '') {
            alert("Residential Address field is pending");
        } else if (home_city == 0) {
            alert("City field is pending");
        } else if (home_pincode == '') {
            alert("Pincode field is pending");
        } else if (occupied_since == '') {
            alert("Occupied Since field is pending");
        } else if (permanent_residential_address == '') {
            alert("Permanent Residential Address field is pending");
        } else if (permanent_home_city == 0) {
            alert("Permanent Residence City field is pending");
        } else if (permanent_home_pincode == '') {
            alert("Permanent Residence Pincode field is pending");
        } else if (permanent_occupied_since == '') {
            alert("Permanent Residence Occupied Since field is pending");
        } else if (employment == '') {
            alert("Employment Type field is pending");
        } else if (official_phone == '') {
            alert("Official Phone field is pending");
        } else if (official_address == '') {
            alert("Official Address field is pending");
        } else if (office_city == 0) {
            alert("Office City field is pending");
        } else if (office_pin == '') {
            alert("Office Pin field is pending");
        } else if (this.state.links.cibil == true) {
            alert("Bureau Status is pending");
        } else if (this.state.links.mobile == true) {
            alert("Mobile Verification is pending");
        } else if (this.state.links.perfios == true) {
            alert("Banking is pending");
        } else if (this.state.links.persional_email == true) {
            alert("Personal Email Verification is pending");
        } else if (this.state.links.docs_upload == false) {
            alert("Document Uploaded is pending");
        } else {
            this.togglecredit_query();
        }

    }


    addpendency(e) {
        if (this.state.comment === '') {
            this.setState({ pendency_commentValid: 'is-invalid' })
        } else {
            this.pendingchangeStatus();
        }
    }


    addcredit_query(e) {
        if (this.state.comment === '') {
            this.setState({ credit_queryValid: 'is-invalid' })
        } else {
            this.creditchangestatus();
        }
    }

    creditchangestatus() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            comment: self.state.comment,
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.CREDIT_PENDENCY,
            status_id: self.state.status_id
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState({ comment: '', commentAdded: true });
                    window
                        .location
                        .reload();
                } else {
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
            });
    }


    pendingchangeStatus() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            comment: self.state.comment,
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.CREDIT_PENDENCY,
            status_id: self.state.status_id
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    // console.log(response);
                    self.setState({ comment: '', commentAdded: true });
                    window
                        .location
                        .reload();
                } else {
                    // console.log(response);
                }
            })
            .catch(function (error) {
                // console.log("Error"); console.log(error);
            });
    }


    commentcheck(e) {
        if (this.state.comment === '') {
            this.setState({ commentValid: 'is-invalid' });
        } else {
            this.changeleadstatus();
        }

    }


    togglecredit_query() {
        this.setState({
            credit_queryModal: !this.state.credit_queryModal
        })
    }


    changeleadstatus() {
        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            comment: self.state.comment,
            lead_id: self.state.lead_details.lead_id,
            mode: Constant.CHANGE_LEAD_STATUS,
            status_id: '74'
        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    //  console.log(response);
                    self.setState({ comment: '', commentAdded: true });
                    self.toggle_loan_revision();
                    window
                        .location
                        .reload();

                } else {
                    //console.log(response);
                }
            })
            .catch(function (error) {
                //console.log(error);
            });
    }


    yyyymmdd(date_to_convert) {

        // $.datepicker.formatDate('yymmdd', new Date());

    }


    handleAmortChange(field, e) {
        this.setState({ amort_request_msg: "" });


        switch (field) {
            case 'amort_approved_amount':

                if (e.target.value <= 0 || e.target.value == "" || e.target.value.match(/[a-zA-Z "!?.-]+$/) || e.target.value.length > 6) {
                    this.setState({ approved_amount_Valid: 'is-invalid' });
                }
                else {
                    this.setState({ approved_amount_Valid: "" });

                }
                break;
            case 'amort_tenure':
                if (e.target.value < 1 || e.target.value == "" || e.target.value.match(/[a-zA-Z "!?.-]+$/)) {
                    this.setState({ tenure_Valid: 'is-invalid' });
                }
                else {
                    this.setState({ tenure_Valid: "" });
                }
                break;
            case 'amort_other':
                if (e.target.value < 0 || e.target.value == "" || e.target.value.match(/[a-zA-Z "!?.-]+$/)) {
                    this.setState({ other_Valid: 'is-invalid' });
                    // console.log("error");
                }
                else {
                    this.setState({ other_Valid: "" });

                }
                break;
            case 'amort_fed':
                if (e.target.value.match(/^(\d{4})\-(\d{1,2})\-(\d{1,2})$/)) {
                    // var fade=e.target.value
                    // fade= new Date(fade);

                    // if (fade.getDate() >28){
                    //     this.setState({ fed_Valid: '' });

                    // }
                    this.setState({ fed_Valid: '' });
                    // console.log("error");
                }
                else {
                    this.setState({ fed_Valid: "is-invalid" });

                }
                break;
            case 'amort_dd':

                if (e.target.value.match(/^(\d{4})\-(\d{1,2})\-(\d{1,2})$/)) {
                    this.setState({ dd_Valid: '' });
                    // console.log("error");
                }
                else {
                    this.setState({ dd_Valid: "is-invalid" });
                }
                break;
            case 'amort_pf':
                if (e.target.value < 0 || e.target.value > 100 || e.target.value == "" || e.target.value.match(/[a-zA-Z "!?.-]+$/)) {
                    this.setState({ pf_Valid: 'is-invalid' });
                    // console.log("error");
                }
                else {
                    this.setState({ pf_Valid: "" });

                }
                break;
            case 'amort_roi':
                if (e.target.value < 0 || e.target.value > 100 || e.target.value == "" || e.target.value.match(/[a-zA-Z "!?.-]+$/)) {
                    this.setState({ roi_Valid: 'is-invalid' });
                    // console.log("error");
                }
                else {
                    this.setState({ roi_Valid: "" });
                }

                break;
            default:
                break;
        }
        let amort_fields = this.state.amort_fields;
        amort_fields[field] = e.target.value;
        this.setState({ amort_fields });

    }


    handleAmortScheduleChange = (key, field) => e => {
        const value = e.target.value;
        const { get_schedule, get_emi_amount, get_starting_balance } = this.state;
        const old_schedule = get_schedule[key];
        // console.log(old_schedule);
        // console.log(get_schedule);

        const new_get_schedule = [...get_schedule];
        // console.log(old_schedule);
        new_get_schedule[key] = {
            ...old_schedule,
            [field]: value,
            amount: get_emi_amount,

        };


        // console.log(new_get_schedule);
        this.setState({
            get_schedule: new_get_schedule,
            get_emi_amount: parseInt(new_get_schedule[key].principal) + parseInt(new_get_schedule[key].interest),
        });

        if (key <= parseInt(this.state.get_tenure) - 2) {
            for (var i = key; i < this.state.get_tenure - 1; i++) {
                new_get_schedule[i].closing_balance = parseInt(new_get_schedule[i].starting_balance - new_get_schedule[i].principal);

                new_get_schedule[i + 1].starting_balance = parseInt(new_get_schedule[i].closing_balance);

            }
        }
        if (key <= parseInt(this.state.get_tenure) - 1) {
            for (var i = key; i < this.state.get_tenure; i++) {

                new_get_schedule[i].closing_balance = parseInt(new_get_schedule[i].starting_balance - new_get_schedule[i].principal);

            }
        }

        var arr = document.getElementsByName("get_schedule_principal_here");
        // console.log(arr);
        var tot = 0;
        for (var i = 0; i < arr.length; i++) {
            if (parseInt(arr[i].value)) { tot += parseInt(arr[i].value) };
        }
        this.setState({
            total_principal_entered: tot
        })
        // document.getElementById("get_total_principal").value = tot;

        // if(tot != this.state.total_principal){
        //     this.state.total_principal_verify = this.state.total_principal - tot;
        // }
        //Sum of all principals after modification from original amort response must be equal to the approved amount.
        if (tot != this.state.approved_amount) {
            this.state.total_principal_verify = this.state.approved_amount - tot;
        }
        else {
            this.setState({ total_principal_verify: 0 });

        }

        var arr_interest = document.getElementsByName("get_schedule_interest_here");
        var tot_interest = 0;
        for (var i = 0; i < arr_interest.length; i++) {
            if (parseInt(arr_interest[i].value)) { tot_interest += parseInt(arr_interest[i].value) };
        }
        this.setState({
            total_interest_entered: tot_interest
        });

        // document.getElementById("get_total_interest").value = tot_interest;
    }


    //API call for generating customer amortization schedule
    callGetAmort() {
        console.log(this.state.finalBifurcayionArray)
        var self = this;
        self.setState(({
            save_amort_error: ""
        }));
        let amort_fields = this.state.amort_fields;
        var querystring = require('querystring');

        var data = querystring.stringify({
            mode: Constant.GET_CUSTOMER_AMORTIZATION_SCHEDULE,
            lead_id: self.state.lead_details.lead_id,
            'approved_amount': this.state.amort_fields["amort_approved_amount"],
            'disbursal_date': this.state.amort_fields["amort_dd"],
            'tenure': this.state.amort_fields["amort_tenure"],
            'first_emi_date': this.state.amort_fields["amort_fed"],
            'processing_fee': this.state.amort_fields["amort_pf"],
            'xirr': this.state.check_xirr,
            'roi': this.state.amort_fields["amort_roi"],
            'other_fees': this.state.amort_fields["amort_other"],
            'other_fees_bifurcation': JSON.stringify(this.state.finalBifurcayionArray)
        })
        axios({
            data: data,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false,
            timeout: 30000
        }).then(function (response) {
            if (response.status == 200) {
                self.setState(prevState => ({
                    get_lender_disbursed_amount_gst: response.data.lender_disbursed_amount_gst,
                    get_lender_disbursed_amount: response.data.lender_disbursed_amount,
                    get_gst: response.data.gst_charge.toFixed(2),
                    get_lender_spdc: response.data.lender_SPDC,
                    get_lender_roi: response.data.lender_roi,
                    get_tenure: response.data.tenure,
                    get_processing_fee: response.data.processing_fee,
                    get_disbursal_date: response.data.disbursal_date,
                    get_first_emi_date: response.data.first_emi_date,
                    get_schedule: response.data.schedule,
                    total_principal: 0,
                    total_interest: 0,
                    total_principal_entered: 0,
                    total_interest_entered: 0,
                    total_principal_verify: 0,
                    total_principal_verify_response: '',
                    amort_request_msg: "",
                    show_amort_schedule_after_parameter_change: 1,
                    approved_amount: response.data.approved_amount
                }));
                for (var i = 0; i < self.state.get_tenure; i++) {
                    self.setState(prevState => ({
                        total_principal: self.state.total_principal + response.data.schedule[i].principal,
                        total_interest: self.state.total_interest + response.data.schedule[i].interest
                    }));
                }
            } else if (response.status == 201) {
                self.setState({ amort_request_msg: response.data.error });
            } else if (response.status == 500) {
                self.setState({ amort_request_msg: response.data.error });
            } else {
                self.setState({ amort_request_msg: response.data.error });
            }
        }).catch(function (error) {
            if (error.code == 'ECONNABORTED') {
                self.setState({ timeouterror: 'Request timed out. Please try again after sometime' })
            }
            self.setState({ amort_request_msg: error });
        });
    }

    setLoanDate() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }

        today = yyyy + '-' + mm + '-' + dd;
        document.getElementById("getAmort_dd").setAttribute("min", today);
        document.getElementById("getAmort_fed").setAttribute("min", today);
    }

    // This function is not getting called as 'Get loan details' button is already showing the same details
    GetSavedAmort() {
        var self = this;
        let amort_fields = this.state.amort_fields;
        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_SAVED_CUSTOMER_AMORT_SCHEDULE,
            lead_id: this.state.lead_details.lead_id

        })
        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({

                        // this.state.get_lender_disbursed_amount=response.data.lender_disbursed_amount;
                        get_lender_disbursed_amount_gst: response.data.lender_disbursed_amount_gst,
                        get_lender_disbursed_amount: response.data.lender_disbursed_amount,
                        get_gst: response.data.gst_charge,
                        get_lender_spdc: response.data.lender_SPDC,
                        get_lender_roi: response.data.lender_roi,
                        get_tenure: response.data.tenure,
                        // get_approved_amount:response.data.approved_amount,
                        get_processing_fee: response.data.processing_fee,
                        get_disbursal_date: response.data.disbursal_date,
                        get_first_emi_date: response.data.first_emi_date,
                        get_schedule: response.data.schedule
                    }));
                } else {
                    self.setState({
                        total_principal_verify_response: response.error
                    })
                }
            })
            .catch(function (error) {
                self.setState({
                    total_principal_verify_response: response.error
                })
            });
    }

    callSetAmortApprove() {
        var self = this;
        var querystring = require('querystring');
        var payload = new FormData();
        payload.append("mode", Constant.SAVE_AMORTIZATION);
        payload.append("lead_id", self.state.lead_details.lead_id);
        payload.append("finalamot", JSON.stringify(this.state.get_schedule));

        axios({
            data: payload,
            headers: {
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN),
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'post',
            url: Constant.API_URL,
            withCredentials: false,
            timeout: 30000

        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        save_amort_error: ""
                    }));

                    window.location.reload();


                } else if (response.status == 201) {
                    // console.log(response.data.error);
                    self.setState({ save_amort_error: response.data.error });


                } else if (response.status == 500) {
                    self.setState({ save_amort_error: response.data });


                } else {
                    self.setState({ save_amort_error: response.data });

                }
            })
            .catch(function (error) {
                if (error.code == 'ECONNABORTED') {
                    // console.log('you can now handle time out here')
                    self.setState({ timeouterror: 'Request timed out. Please try again after sometime' })
                }

                // this.setState({ save_amort_error: error });

            });
    }


    tabPane() {
        e.preventDefault();
    }

    handleUserPermanentResidenceType = (e) => {
        //      str = str.replace(/\d(?=\d{4})/g, "*");
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value
        }, () => {
            this.validatePemanentResidenceType(name, value);
        });
    }

    validatePemanentResidenceType(name, value) {

        switch (name) {

            case "perResAddress":

                if (value == "" || value == null || value.length < 5 || value.match(/^[0-9]*$/) || value.match(/^[!@$%^*,?":{}/\|<>]+$/) || value.match(/^\S*$/) && this.state.lead_details.profile_editable) {
                    this.setState({
                        permanentAddressValid: 'is-invalid',
                    });
                } else {
                    this.setState({
                        permanentAddressValid: ""
                    });

                }
                break;

            case "per_occupied_since":

                if (value.match(/^\d{4}$/) && value <= (new Date().getFullYear()) && value >= 1950 || value == "" || value == null && this.state.lead_details.profile_editable) {
                    this.setState({
                        permanentOccupiedSinceValid: '',

                    });
                } else {
                    this.setState({
                        permanentOccupiedSinceValid: 'is-invalid',

                    });
                }

            case "per_reg_landmark":

                if (value.length <= 2 || value == "" || !value.match(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/) || value.length > 40) {
                    this.setState({
                        permanentAddressLandmarkValid: 'is-invalid'
                    });

                } else {
                    this.setState({
                        permanentAddressLandmarkValid: ""
                    });
                }

                break;

            case "perSelectCity":

                if (value == '0' || value == '' || value == 0 || value == null && this.state.lead_details.profile_editable) {
                    this.setState({
                        permanentCityValid: "is-invalid"
                    });


                } else {
                    this.setState({
                        permanentCityValid: ""
                    });
                }

                break;

            case "perSelectState":

                if (value == '0' || value == '' || value == 0 || value == null && this.state.lead_details.profile_editable) {
                    this.setState({
                        permanentStateValid: "is-invalid"
                    });


                } else {
                    this.setState({
                        permanentStateValid: ""
                    });
                    this.getPermanentAddCities(value);
                }

                break;

            case "perPinCode":

                if (value == "" || !value.match(/^\d{6}$/) || value == null && this.state.lead_details.profile_editable) {
                    this.setState({
                        permanentResidencePincodeValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        permanentResidencePincodeValid: ""
                    });
                }
                break;
            case "perOwnershipType":

                if (value == "" || value == "0" || value == null && this.state.lead_details.profile_editable) {
                    this.setState({
                        perResidenceTypeValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        perResidenceTypeValid: ""
                    });
                }
                break;

            default:

                break;

        }
        if (value != "0") {
            this.setState({
                ResidenceType_valid: "",
            });
        }
        else {

            this.setState({
                ResidenceType_valid: "is-invalid",
            });

        }

    }

    getPermanentResDetails = () => {
        let self = this;
        let querystring = require('querystring');
        let payload = querystring.stringify({
            mode: Constant.GET_PERMANENT_ADDRESS_DETAILS,
            lead_id: '',
            application_id: self.state.lead_details.lead_id,
        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN)
            },
            withCredentials: false,
            data: payload,
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data != null) {
                    self.setState(prevState => ({
                        perResAddress: response.data.address,
                        per_reg_landmark: response.data.landmark,
                        per_occupied_since: response.data.occupied_since,
                        perSelectCity: response.data.city_id,
                        perSelectState: response.data.state_id,
                        perPinCode: response.data.pin,
                        perOwnershipType: response.data.ownership_type_id
                    }));
                }
                self.getPermanentAddCities(self.state.perSelectState);
            } else if (response.status == 201) {
                console.log("Error while fetching reference details: 201");
            }
        }).catch(function (error) {
            console.log('Error:', error);
        });
    }

    setPermanentAddressDetails = () => {
        let self = this;
        let querystring = require('querystring');
        let payload = querystring.stringify({
            mode: Constant.SET_PERMANENT_ADDRESS_DETAILS,
            lead_id: self.state.lead_details.lead_id,
            address: self.state.perResAddress,
            landmark: self.state.per_reg_landmark,
            occupied_since: self.state.per_occupied_since,
            city_id: self.state.perSelectCity,
            pincode: self.state.perPinCode,
            state_id: self.state.perSelectState,
            ownership_type: self.state.perOwnershipType
        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),
            },
            withCredentials: false,
            data: payload,
        }).then(function (response) {
            if (response.status == 200) {
                console.log("Success!");
            } else if (response.status == 201) {
                console.log("Enter all the details before saving");
            }
        }).catch(function (error) {
            console.log('Error:', error);
        });
    }

    handleUserInputOVD(e) {

        var fieldName = e.target.name;
        var value = e.target.value;
        this.setState({ [fieldName]: value });

        switch (fieldName) {

            case 'aadhaar':
                if (/^\d{12}$/.test(value)) {
                    this.setState({
                        aadhaarValid: 'is-valid'
                    });
                } else {
                    this.setState({
                        aadhaarValid: 'is-invalid',

                    });
                }
                break;

            case 'dl':
                if (value != "" && value != " " && value != null) {
                    this.setState({ dlValid: "isvalid" });
                }
                else {
                    this.setState({
                        dlValid: 'is-invalid',

                    });

                }
                break;

            case 'passport':
                if (value != "" && value != " " && value != null) {
                    this.setState({ passportValid: "isvalid" });
                }
                else {
                    this.setState({
                        passportValid: 'is-invalid',

                    });

                }
                break;

            case 'voterIDNumber':
                if (value != "" && value != " " && value != null) {
                    this.setState({
                        voterIDValid: "is-valid"
                    });
                }
                else {
                    this.setState({
                        voterIDValid: 'is-invalid',

                    });
                }
                break;

            default:
                break;
        }

    }


    getAllStates() {
        var self = this;

        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_REFERENCE_STATES,

        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        allStates: response.data,
                    }));

                }

                else if (response.status == 201) {

                    console.log("Error while fetching states : 201")
                }

            }).catch(function (error) {
                // console.log('Error:', error);    
            });
    }

    getPermanentAddCities = (state_id) => {

        var self = this;
        var querystring = require('querystring');
        var payload = querystring.stringify({
            mode: Constant.GET_REFERENCE_CITIES,
            state_id: state_id
        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        permanentCities: response.data,
                    }));

                }

                else if (response.status == 201) {

                    alert("Error while fetching cities: 201");

                }

                else if (response.status == 404) {

                    alert("Error: Could not fetch cities (404)");

                }

            }).catch(function (error) {
                // console.log('Error:', error);
            });
    }

    // handle bifurcation form submit
    addOtherNumber = () => {
        // console.log(this.state.selectedBifurcationValue)
        var valueArray = [];
        var DropdownArray = [];

        var DropdownSet = document.getElementsByClassName('selectDropDownValue')
        for (let j = 0; j < DropdownSet.length; j++) {
            DropdownArray.push(DropdownSet[j].value);
        }

        var valueSet = document.getElementsByClassName('activeValueInput');
        for (let i = 0; i < valueSet.length; i++) {
            valueArray.push(valueSet[i].value);
        }
        let sum = valueArray.reduce((acc, val) => {
            return parseInt(acc) + parseInt(val);
        })
        if (sum === parseInt(this.state.amort_fields["amort_other"])) {
            for (let i = 0; i < DropdownArray.length; i++) {
                var tempObj = {
                    'type': DropdownArray[i],
                    'amount': valueArray[i]
                }
                this.state.finalBifurcayionArray.push(tempObj);
            }
            console.log("this.state.finalBifurcayionArray", this.state.finalBifurcayionArray)
            this.setState(prevState => ({
                bifurcationModal: !this.state.bifurcationModal,
            }));
        } else if (sum > parseInt(this.state.amort_fields["amort_other"])) {
            alert("Other bifurcation value is greater than upfront value.");
        } else if (sum < parseInt(this.state.amort_fields["amort_other"])) {
            alert("Other bifurcation value is less than upfront value.");
        } else if (sum === '') {
            alert("please fill the form.");
        }
    }

    // add input 
    appendInput() {
        var newInput = `input-${this.state.inputs.length}`;
        this.setState(prevState => ({ inputs: prevState.inputs.concat([newInput]) }));
    }


    // Open bifurcation modal
    toggleBifurcationModal = () => {
        console.log("=============>")
        var firstInput = ['input-0']
        this.setState(prevState => ({
            bifurcationModal: !this.state.bifurcationModal,
            inputs: firstInput
        }));
    }

    // // handle bifurcation value
    // handleChangeBifurcation = (event, index) => {
    //     let selectedBifurcationValue = [...this.state.selectedBifurcationValue]   //creating the copy
    //     //adding new data
    //     selectedBifurcationValue.push(
    //         event.target.value
    //     );
    //     //updating the state value
    //     this.setState({ selectedBifurcationValue });
    // }


    render() {
        let loan_status_check = this.state.lead_details.loan_status === 'Disbursed' || this.state.lead_details.loan_status === 'Approved' 
        || this.state.lead_details.lead_status == 'Pendency' ? 'hide' : 'show';
        window.localStorage.setItem('loan_status_check', loan_status_check);
        const { get_schedule, get_emi_amount } = this.state;
        var opts = {};
        if (this.state.loan_approved) {
            opts['readOnly'] = 'readOnly';
        }

        // if (this.state.firstNameValid ||
        //     this.state.lastNameValid ||
        //     this.state.emailValid ||
        //     this.state.mobileValid ||
        //     this.state.panValid ||
        //     this.state.passportValid ||
        //     this.state.aadhaarValid ||
        //     this.state.dlValid ||
        //     this.state.voterIDValid ||
        //     this.state.residenceTypeValid ||
        //     this.state.resValid ||
        //     this.state.reg_landmarkValid ||
        //     this.state.pinValid ||
        //     this.state.occupied_sinceValid ||
        //     this.state.residenceTypeValid ||
        //     this.state.permanentAddressValid ||
        //     this.state.reg_landmarkValid ||
        //     this.state.permanentStateValid ||
        //     this.state.permanentCityValid ||
        //     this.state.permanentResidencePincodeValid ||
        //     this.state.permanentOccupiedSinceValid ||
        //     this.state.office_addressValid ||
        //     this.state.office_landmarkValid||
        //     this.state.office_pinValid ||
        //     this.state.office_phone_number_valid ||
        //     this.state.account_noValid ||
        //     this.startLoader.ifsc_codeValid  == "is-invalid"
        //     ){
        //         submit_form_check = ""
        // }

        // else{
        //     submit_form_check = "1"
        // }

        // submit_form_check = submit_form_check || this.state.enable_submit;

        var otherFeesTypes = this.state.otherFeesTypes;
        return (

            <div className="loanDetails_page">

                <VerificationStatus
                    phone={this.state.lead_details.mobile_number}
                    phoneVerified={this.state.lead_details.mobile_verification}
                    showPhoneVerify={this.state.links.mobile}
                    phoneToggle={this.toggleMobileModal}
                    email={this.state.lead_details.email}
                    emailVerified={this.state.lead_details.persional_email_verification}
                    emailToggle={this.toggleEmailModal}
                    CibilToggle={this.toggleCibilModal}
                    showCibilVerify={this.state.links.cibil}
                    showEmailVerify={this.state.links.persional_email}
                    ofcEmail={this.state.lead_details.office_email}
                    ofcEmailVerified={this.state.lead_details.profesional_email_verification}
                    cibilScoreVerified={this.state.lead_details.cibil_score_verification}
                    ofcEmailToggle={this.toggleOfcEmailModal}
                    showOfcEmailVerify={this.state.links.profesional_email}
                    cibilStatus={this.state.lead_details.cibil_status}
                    perfiosStatus={this.state.lead_details.perfios_status}
                    showPerfiosVerify={this.state.links.perfios}
                    togglePerfios={this.togglePerfiosModal}
                    docsUploaded={this.state.lead_details.docs_uploaded}
                    showDocUploadLink={this.state.links.docs_uploaded}
                    toggleDocLink={this.toggleDocLinkModal} />
                <Row>
                    <Col xs="12" sm="12" md="12">
                        <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" href="#tab1_loan_details" role="tab" data-toggle="tab">Loan Details</a>
                            </li>

                            {
                                (this.state.check_xirr && !this.state.loan_approved) ?
                                    <li className="nav-item">
                                        <a className="nav-link" href="#tab2_amortization" role="tab" data-toggle="tab">Customer Amortization Schedule</a>
                                    </li>
                                    :
                                    ""
                            }
                            <li className="nav-item">
                                <a className="nav-link" href="#tab3_comments" role="tab" data-toggle="tab">Comments</a>
                            </li>
                        </ul>

                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane fade in active" id="tab1_loan_details">

                                <Card>
                                    <CardHeader>
                                        <strong>{this.state.lead_details.customer_name}</strong>
                                        <br></br>
                                        <Badge
                                            color={this.state.statusColor}
                                            style={{
                                                padding: 1 + 'em'
                                            }}>Loan Status:
                                            <strong>{this.state.appStatus}</strong>
                                        </Badge>{' '}

                                        {
                                            this.state.lead_details.target_for_card == '1'
                                                ? <i className="fa fa-check"></i>
                                                : ""
                                        }

                                        {
                                            this.state.lead_details.application_status == 'complete'
                                                ? <Button className="stashfin-cardd">
                                                    {
                                                        (
                                                            this.state.lead_details.target_for_card == '0' || this.state.lead_details.card_status == '0'
                                                        )
                                                            ? <img
                                                                src="https://lms.stasheasy.com/assets/images/card-icon.png"
                                                                id="stashfin-card"
                                                                onClick={this.toggleNotRegesteredCard} />
                                                            : <img
                                                                src="https://lms.stasheasy.com/assets/images/card-icon.png"
                                                                id="stashfin-card"
                                                                onClick={this.toggleCardRegistered} />

                                                    }
                                                </Button>

                                                : ""
                                        }

                                        {
                                            this.state.lead_details.lead_status == 'Pendency'
                                                ? <Button
                                                    className="float-right"
                                                    outline="outline"
                                                    color="primary"
                                                    id="ab"
                                                    size="sm"
                                                    onClick={this.pendency_resolve}>
                                                    <i className="fa fa-dot-circle-o"></i>
                                                    Pendency Resolved</Button>
                                                : ""
                                        }

                                        {
                                            this.state.lead_details.lead_status == 'Credit Query'
                                                ? <Button
                                                    className="float-right"
                                                    outline="outline"
                                                    color="primary"
                                                    id="ab"
                                                    size="sm"
                                                    onClick={this.credit_query}>
                                                    <i className="fa fa-dot-circle-o"></i>
                                                    Credit Query Resolved</Button>
                                                : ""
                                        }

                                        {/* {
                                            (this.state.lead_details.loan_status == 'Approved')
                                                ? <Button
                                                    className="float-right"
                                                    outline="outline"
                                                    color="primary"
                                                    id="ab"
                                                    size="sm"
                                                    onClick={this.toggle_loan_revision}>
                                                    <i className="fa fa-dot-circle-o"></i>
                                                    &nbsp;Loan Revision</Button>

                                                : ""
                                        } */}

                                        {/* {
                                            (this.state.lead_details.loan_status == 'Approved')
                                                ? <Button
                                                    className="float-right"
                                                    outline="outline"
                                                    color="primary"
                                                    id="ab"
                                                    size="sm"
                                                    onClick={this.fosSheetDetails}>
                                                    <i className="fa fa-dot-circle-o"></i>
                                                    &nbsp;Fos Sheet</Button>
                                                : ""
                                        } */}
                                        <Button
                                            className="float-right"
                                            outline="outline"
                                            color="primary"
                                            id="ab"
                                            size="sm"
                                            onClick={this.toggleuploaddocument}>
                                            <i className="fa fa-dot-circle-o"></i>
                                            &nbsp;Upload Documents</Button>


                                    </CardHeader>

                                    <CardBlock className="card-body">

                                        <fieldset id='form1'>

                                            <Form action='' className="form-horizontal" id="leadupdateform">
                                                <FormGroup row="row">
                                                    <Col md="6">
                                                        <Label>Fields marked with an asterisk(<span style={{ color: "red" }}>*</span>) are mandatory.</Label>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="select">Product Type</Label>
                                                    </Col>
                                                    <Col md="4" className="id-style">
                                                        <span>{this.state.lead_details.product_code}</span>
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Loan Reference ID</Label>
                                                    </Col>
                                                    <Col md="4" className="id-style">
                                                        <span>{this.state.lead_details.ref_no}</span>
                                                    </Col>

                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Virtual Account</Label>
                                                    </Col>
                                                    <Col md="4" className="id-style">
                                                        <span
                                                            style={{
                                                                textAlign: "center"
                                                            }}>{this.state.virtual_ac_no}</span>
                                                    </Col>

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Reference Count</Label>
                                                    </Col>
                                                    <Col md="4" className="id-style">
                                                        <span
                                                            style={{
                                                                textAlign: "center"
                                                            }}>{this.state.reference_count}</span>
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Ext Reference ID<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                        <Col md="4">
                                                            <Input type="text" id="text-input" name="bank_loan_ref_id" placeholder=""  value={loan_status_check == 'hide' ? "********" : this.state.bank_loan_ref_id} onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} />
                                                        </Col>
                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Loan Reason</Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="selectreason"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.selectreason}
                                                            id="select"
                                                            onChange={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .loan_reason
                                                                    .map(
                                                                        (data, key) => <option key={key} value={data.loan_reason}>{data.loan_reason}</option>
                                                                    )
                                                            }
                                                        </Input>
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">First Name<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="first-name"
                                                            name="firstName"
                                                            placeholder=""
                                                            className={this.state.firstNameValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.firstName}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup className="field-row" row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Last Name<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="last-name"
                                                            name="lastName"
                                                            placeholder=""
                                                            className={this.state.lastNameValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.lastName}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="select">Gender<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="gender"
                                                            id="gender"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.gender}
                                                            className={this.state.genderValid}
                                                            onChange={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                        </Input>
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup className="field-row" row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="select">Date of Birth<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="date"
                                                            name="dateOfBirth"
                                                            className={this.state.dateOfBirthValid}
                                                            id="date-of-birth"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.dateOfBirth}
                                                            onChange={(event) => this.handleUserInput(event)}></Input>
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="email-input">Email<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="email"
                                                            id="email"
                                                            name="email"
                                                            placeholder=""
                                                            className={this.state.emailValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.email}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="contact-input">Mobile number<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            id="mobile-number"
                                                            name="mobile"
                                                            placeholder=""
                                                            className={this.state.mobileValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.mobile}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">PAN Number<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="pan-number"
                                                            name="panNumber"
                                                            placeholder=""
                                                            className={this.state.panValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.panNumber}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col xs="2" md="2">
                                                        <Label htmlFor="text-input">OVD Document<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>

                                                    <Col xs="4" md="4">
                                                        <Input type="select" name="selectOVD" value={this.state.selectOVD} id="select" onChange={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select an OVD Document</option>
                                                            {this.state.ovd_docs.map((data, key) =>
                                                                <option key={key} value={loan_status_check == 'hide' ? "********" : data.id}>{data.name}</option>

                                                            )}
                                                        </Input>
                                                    </Col>
                                                    {this.state.selectOVD == "2" ?
                                                        [<Col xs="2" md="2">
                                                            <Label htmlFor="text-input">Driving Licence Number<span style={{ color: "red" }}>*</span></Label>
                                                        </Col>,

                                                        <Col xs="4" md="4">
                                                            <Input type="text" id="text-input" name="dl" className={this.state.dlValid} placeholder="" value={loan_status_check == 'hide' ? "********" : this.state.dl} maxLength="16" onChange={(event) => this.handleUserInputOVD(event)}
                                                                onInput={(e) => {
                                                                    e.target.value = (e.target.value).toString().slice(0, 15).toUpperCase()
                                                                }} onBlur={(event) => this.handleUserInputOVD(event)} />
                                                        </Col>]
                                                        :
                                                        this.state.selectOVD == "3" ?
                                                            [<Col xs="2" md="2">
                                                                <Label htmlFor="text-input">Passport Number<span style={{ color: "red" }}>*</span></Label>
                                                            </Col>,

                                                            <Col xs="4" md="4">
                                                                <Input type="text" id="text-input" className={this.state.passportValid} name="passport" placeholder="" value={ loan_status_check == 'hide' ? "********" : this.state.passport} maxLength="8" onChange={(event) => this.handleUserInputOVD(event)}
                                                                    onInput={(e) => {
                                                                        e.target.value = (e.target.value).toString().slice(0, 12).toUpperCase()
                                                                    }} onBlur={(event) => this.handleUserInputOVD(event)} />
                                                            </Col>]
                                                            :
                                                            this.state.selectOVD == "4" ?
                                                                [<Col xs="2" md="2">
                                                                    <Label htmlFor="text-input">Voter ID Number<span style={{ color: "red" }}>*</span></Label>
                                                                </Col>,

                                                                <Col xs="4" md="4">
                                                                    <Input tye="text" id="text-input" className={this.state.voterIDValid} name="voterIDNumber" placeholder="" value={loan_status_check == 'hide' ? "********" : this.state.voterIDNumber} maxLength="12" onChange={(event) => this.handleUserInputOVD(event)}
                                                                        onInput={(e) => {
                                                                            e.target.value = (e.target.value).toString().slice(0, 10).toUpperCase()
                                                                        }} onBlur={(event) => this.handleUserInputOVD(event)} />
                                                                </Col>]
                                                                :
                                                                this.state.selectOVD == "1" ?
                                                                    [<Col xs="2" md="2">
                                                                        <Label htmlFor="text-input">Aadhaar Number<span style={{ color: "red" }}>*</span></Label>
                                                                    </Col>,

                                                                    <Col xs="4" md="4">
                                                                        <Input type="number" id="text-input" name="aadhaar" className={this.state.aadhaarValid} placeholder="" value={loan_status_check == 'hide' ? "********" : this.state.aadhaar} maxLength="12" onChange={(event) => this.handleUserInputOVD(event)} onInput={(e) => {
                                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12)
                                                                        }} min={0} onBlur={(event) => this.handleUserInputOVD(event)} />
                                                                    </Col>]
                                                                    :

                                                                    ""
                                                    }


                                                </FormGroup>

                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="select">Current Residence type<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="residenceType"
                                                            className={this.state.residenceTypeValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.residenceType}
                                                            id="residence-type"
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .ownership_type
                                                                    .map(
                                                                        (data, key) => <option key={key} value={data.id}>{data.ownership_type}</option>
                                                                    )
                                                            }
                                                        </Input>

                                                    </Col>

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Current  Residence Address<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="Residence-address"
                                                            name="resAddress"
                                                            placeholder=""
                                                            className={this.state.resValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.resAddress}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />

                                                        <Input
                                                            type="text"
                                                            id="Residence-address"
                                                            name="resAddress2"
                                                            placeholder=""
                                                            className={this.state.resValid2}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.resAddress2}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>

                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Current Residence Landmark</Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="reg_landmark"
                                                            name="reg_landmark"
                                                            placeholder=""
                                                            className={this.state.reg_landmarkValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.reg_landmark}
                                                            onChange={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="select">Current Residence City<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="selectCity"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.selectCity}
                                                            className="resCityValid"
                                                            id="home-city"
                                                            onChange={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .cities
                                                                    .map(
                                                                        (data, key) => <option key={key} value={data.city_id}>{data.city_name}
                                                                            ({data.state_name})</option>
                                                                    )
                                                            }
                                                        </Input>

                                                    </Col>

                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Current Residence PIN Code<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            id="home-pincode"
                                                            name="pinCode"
                                                            placeholder=""
                                                            className={this.state.pinValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.pinCode}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>

                                                    <Col md="2">
                                                        <Label htmlFor="select">Current Residence Occupied Since<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            name="occupied_since"
                                                            id="occupied-since"
                                                            min={1901}
                                                            placeholder="YYYY"
                                                            className={this.state.occupied_sinceValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.occupied_since}
                                                            onChange={(event) => this.handleUserInput(event)}></Input>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="select">Permanent Residence type<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="perOwnershipType"
                                                            className={this.state.perResidenceTypeValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.perOwnershipType}
                                                            id="perResidence-type"
                                                            onChange={(event) => this.handleUserPermanentResidenceType(event)}
                                                            onBlur={(event) => this.handleUserPermanentResidenceType(event)}>
                                                            <option value="">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .ownership_type
                                                                    .map(
                                                                        (data, key) => <option key={key} value={data.id}>{data.ownership_type}</option>
                                                                    )
                                                            }
                                                        </Input>

                                                    </Col>

                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Permanent Residence Address<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="permanent-residential-address"
                                                            name="perResAddress"
                                                            placeholder=""
                                                            className={this.state.permanentAddressValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.perResAddress}
                                                            onChange={(event) => this.handleUserPermanentResidenceType(event)}
                                                            onBlur={(event) => this.handleUserPermanentResidenceType(event)} />

                                                    </Col>



                                                </FormGroup>

                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Permanent Residence Landmark</Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="per_reg_landmark"
                                                            name="per_reg_landmark"
                                                            placeholder=""
                                                            className={this.state.permanentAddressLandmarkValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.per_reg_landmark}
                                                            onChange={(event) => this.handleUserPermanentResidenceType(event)} />

                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="select">Permanent Residence State<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="perSelectState"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.perSelectState}
                                                            id="permanent-home-city"
                                                            className={this.state.permanentStateValid}
                                                            onChange={(event) => this.handleUserPermanentResidenceType(event)}>
                                                            <option value="0">Please select</option>
                                                            {
                                                                this.state.allStates.map(
                                                                    (data, key) => <option key={key} value={data.id}>{data.state_name}
                                                                    </option>
                                                                )
                                                            }
                                                        </Input>

                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="select">Permanent Residence City<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="perSelectCity"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.perSelectCity}
                                                            className={this.state.permanentCityValid}
                                                            id="permanent-home-city"
                                                            onChange={(event) => this.handleUserPermanentResidenceType(event)}
                                                        >
                                                            <option value="0">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .permanentCities
                                                                    .map(
                                                                        (data, key) => <option key={key} value={data.id}>{data.city_name}
                                                                        </option>
                                                                    )
                                                            }
                                                        </Input>

                                                    </Col>


                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Permanent Residence PIN Code<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            id="permanent-home-pincode"
                                                            name="perPinCode"
                                                            placeholder=""
                                                            className={this.state.permanentResidencePincodeValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.perPinCode}
                                                            onChange={(event) => this.handleUserPermanentResidenceType(event)}
                                                            onBlur={(event) => this.handleUserPermanentResidenceType(event)} />
                                                    </Col>

                                                </FormGroup>

                                                <FormGroup row="row">

                                                    <Col md="2">
                                                        <Label htmlFor="select">Permanent Residence Occupied Since<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            name="per_occupied_since"
                                                            id="permanent-occupied-since"
                                                            min={1901}
                                                            className={this.state.permanentOccupiedSinceValid}
                                                            placeholder="YYYY"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.per_occupied_since}
                                                            onChange={(event) => this.handleUserPermanentResidenceType(event)}></Input>

                                                    </Col>

                                                </FormGroup>

                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="select">Office Address<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            name="office_address_line_1"
                                                            id="office-address"
                                                            placeholder="Address Line 1"
                                                            className={this.state.office_addressValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.office_address_line_1}
                                                            onChange={(event) => this.handleUserInput(event)}></Input>

                                                        <Input
                                                            type="text"
                                                            name="office_address_line_2"
                                                            id="office-address"
                                                            placeholder="Address Line 2 (Optional)"
                                                            className={this.state.office_addressValid2}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.office_address_line_2}
                                                            onChange={(event) => this.handleUserInput(event)}></Input>
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Office Landmark</Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="office_landmark"
                                                            autoComplete="off"
                                                            name="office_landmark"
                                                            placeholder=""
                                                            className={this.state.office_landmarkValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.office_landmark}
                                                            onChange={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="select">Office City<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="office_city"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.office_city}
                                                            id="office-city"
                                                            onChange={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .cities
                                                                    .map(
                                                                        (data, key) => <option key={key} value={data.city_id}>{data.city_name}
                                                                            ({data.state_name})</option>
                                                                    )
                                                            }
                                                        </Input>
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="select">Office Pin<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            name="office_pin"
                                                            id="office-pin"
                                                            className={this.state.office_pinValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.office_pin}
                                                            onChange={(event) => this.handleUserInput(event)}></Input>
                                                    </Col>
                                                </FormGroup >
                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="email-input">Official Phone<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            id="official-phone"
                                                            name="ofcPhone"
                                                            placeholder=""
                                                            className={this.state.office_phone_number_valid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.ofcPhone}
                                                            onChange={(event) => this.handleUserInput(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />

                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="select">Highest Education</Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="selecteducation"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.selecteducation}
                                                            id="select"
                                                            onChange={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .highest_education
                                                                    .map(
                                                                        (data, key) => <option key={key} value={data.education}>{data.education}</option>
                                                                    )
                                                            }
                                                        </Input>
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="select">Employment type<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="select"
                                                            name="incomeMode"
                                                            id="employment"
                                                            value={loan_status_check == 'hide' ? "********" : this.state.incomeMode}
                                                            onChange={(event) => this.handleUserInput(event)}>
                                                            <option value="0">Please select</option>
                                                            {
                                                                this
                                                                    .state
                                                                    .employment_types
                                                                    .map((data, key) => <option key={key} value={data.value}>{data.type}</option>)
                                                            }
                                                        </Input>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Account Number<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="number"
                                                            id="passwordfield"
                                                            autoComplete="off"
                                                            name="account_no"
                                                            maxLength="18"
                                                            onKeyDown={(event) => this.DisableCopyPaste(event)}
                                                            onMouseDown={(event) => this.DisableCopyPaste(event)}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.account_no}
                                                            className={this.state.account_noValid}
                                                            onChange={(event) => this.handleUserInputaccountno(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                        <span id="clickableAwesomeFont">
                                                            <i className="fa fa-eye" id="check" onClick={this.mypassword} style={{ marginTop: '7px', }}></i>
                                                        </span>
                                                    </Col>
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">IFSC Code<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="text-input"
                                                            name="ifsc_code"
                                                            onKeyDown={(event) => this.DisableCopyPaste(event)}
                                                            onMouseDown={(event) => this.DisableCopyPaste(event)}
                                                            className={this.state.ifsc_codeValid}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.ifsc_code}
                                                            onChange={(event) => this.handleUserInputifsc(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row="row">
                                                    <Col md="2">
                                                        <Label htmlFor="text-input">Name as per Bank account<span style={{ color: "red" }}>*</span></Label>
                                                    </Col>
                                                    <Col md="4">
                                                        <Input
                                                            type="text"
                                                            id="text-input"
                                                            autoComplete="off"
                                                            name="nameasper_bank"
                                                            onKeyDown={(event) => this.DisableCopyPaste(event)}
                                                            onMouseDown={(event) => this.DisableCopyPaste(event)}
                                                            value={loan_status_check == 'hide' ? "********" : this.state.nameasper_bank}
                                                            // className={this.state.nameasper_bankValid}
                                                            onChange={(event) => this.handleUserInputNameAsPerBank(event)}
                                                            onBlur={(event) => this.handleUserInput(event)} />
                                                    </Col>
                                                </FormGroup>

                                                <References friendReference={this.state.friendReference} colleagueReference={this.state.colleagueReference}
                                                    lead_id={this.state.lead_details.lead_id} loan_approved={this.state.loan_approved} />

                                                {
                                                    this.state.incomeMode === "salaried" ?
                                                        <Employed
                                                            salaryMode={this.state.salaryMode}
                                                            salary={this.state.salary}
                                                            salaryModeSelect={this.state.salaryModeSelect}
                                                            companyName={this.state.companyName}
                                                            companies={this.state.companies}
                                                            companyclick={this.companyclick}
                                                            showcompanylist={this.showcompanylist}
                                                            showcompanyfilter={this.state.showcompanyfilter}
                                                            workStartYear={this.state.workStartYear}
                                                            office_email={this.state.office_email}
                                                            profession={this.state.profession}
                                                            designation={this.state.designation}
                                                            experience={this.state.experience}
                                                            handleUserInput={this.handleUserInput}
                                                            handleEnableSubmit={this.handleEnableSubmit}
                                                            salaryValid={this.state.salaryValid}
                                                            designationOther={this.state.designationOther}
                                                            otherProfession={this.state.otherProfession}
                                                            professions={this.state.professions}
                                                            designations={this.state.designations} />
                                                        : this.state.incomeMode === "self employed"
                                                            ? <Business
                                                                salary={this.state.salary}
                                                                companyName={this.state.companyName}
                                                                handleUserInput={this.handleUserInput}
                                                                companies={this.state.companies}
                                                                companyclick={this.companyclick}
                                                                showcompanylist={this.showcompanylist}
                                                                showcompanyfilter={this.state.showcompanyfilter}
                                                                salaryValid={this.state.salaryValid} />
                                                            : <Col md="4"></Col>
                                                }

                                                <FormGroup row="row">
                                                    <FormText color="danger" id="danger">{this.state.serverError}</FormText>
                                                    <FormText color="success" id="danger">{this.state.serverMsg}</FormText>
                                                    <FormText color="danger" id="danger">{this.state.ovdErrorMsg}</FormText>
                                                    <FormText color="danger" id="danger">{this.state.formErrorMsg || ""}</FormText>

                                                    <div style={{ color: 'red', paddingLeft: '10%' }}>{this.state.toggleEMIsErrorMsg}</div>

                                                </FormGroup>
                                            </Form>


                                        </fieldset>


                                    </CardBlock>
                                    <CardFooter>

                                        <FormGroup row="row">
                                            {
                                                this.state.lead_details.profile_editable == true
                                                    ? <Col xs="12" sm="12" md="3">
                                                        <Button outline="outline" size="sm" color="primary" onClick={this.updateLead}>
                                                            <i className="fa fa-dot-circle-o"></i>
                                                            Submit</Button>
                                                    </Col>
                                                    : <Col xs="12" sm="12" md="3">
                                                        <Button
                                                            outline="outline"
                                                            color="primary"
                                                            size="sm"
                                                            onClick={this.toggleEmiModal}>
                                                            <i className="fa fa-dot-circle-o"></i>
                                                            Show EMI Details</Button>
                                                    </Col>
                                            }
                                            <Col xs="12" sm="12" md="3">
                                                <Button
                                                    outline="outline"
                                                    color="primary"
                                                    size="sm"
                                                    onClick={this.toggleComment}>
                                                    <i className="fa fa-dot-circle-o"></i>
                                                    Add comment</Button>
                                            </Col>

                                            <Col xs="12" sm="12" md="3">
                                                <Button
                                                    outline="outline"
                                                    color="primary"
                                                    size="sm"
                                                    onClick={this.toggleSendPDF}>
                                                    <i className="fa fa-dot-circle-o"></i>
                                                    Application Form Pdf Email</Button>
                                            </Col>
                                            {
                                                this.state.lead_details.flag == 0
                                                    ? <div></div>
                                                    : <Col xs="12" sm="12" md="3">
                                                        <Button
                                                            outline="outline"
                                                            color="primary"
                                                            size="sm"
                                                            onClick={this.toggleCreateNewLoan}>
                                                            <i className="fa fa-dot-circle-o"></i>
                                                            Create Another Loan
                                                        </Button>
                                                    </Col>

                                            }
                                        </FormGroup>
                                    </CardFooter>
                                </Card>
                            </div>
                            <div role="tabpanel" className="tab-pane fade" id="tab2_amortization">

                                <div className="row">
                                    <div className="getAmort-body-heading col-md-12 col-lg-12">

                                        Enter the loan details

                                    </div>
                                </div>
                                <div className="container">
                                    <div className="row">
                                        {
                                            (this.state.loan_approved == false) ?
                                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <form role="form" id="getAmort_form">

                                                        <div className="row">

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_approved_amount" type="number" required="required" id="getAmort_approved_amount" min="1" onChange={this.handleAmortChange.bind(this, "amort_approved_amount")} value={this.state.amort_fields["amort_approved_amount"]} />
                                                                <label htmlFor="input" className="getAmort-control-label">Approved Amount</label><i className="getAmort-bar"></i>
                                                            </div>

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_roi" type="number" required="required" id="getAmort_roi" min="0" step="0.000000001" onChange={this.handleAmortChange.bind(this, "amort_roi")} value={this.state.amort_fields["amort_roi"]} />
                                                                <label htmlFor="input" className="getAmort-control-label">Rate of Interest (%)</label><i className="getAmort-bar"></i>
                                                            </div>

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="Amort_tenure" type="number" required="required" id="getAmort_tenure" min="0" onChange={this.handleAmortChange.bind(this, "amort_tenure")} value={this.state.amort_fields["amort_tenure"]} />
                                                                <label htmlFor="input" className="getAmort-control-label">Loan Tenure</label><i className="getAmort-bar"></i>
                                                            </div>

                                                        </div>

                                                        <div className="row">

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_pf" type="number" required="required" id="getAmort_pf" min="0" step="0.001" onChange={this.handleAmortChange.bind(this, "amort_pf")} value={this.state.amort_fields["amort_pf"]} />
                                                                <label htmlFor="input" className="getAmort-control-label">Processing Fee (%)</label><i className="getAmort-bar"></i>
                                                            </div>

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_dd" type="date" required="required" id="getAmort_dd" min='1899-01-01' onChange={this.handleAmortChange.bind(this, "amort_dd")} value={this.state.amort_fields["amort_dd"]} />
                                                                <label htmlFor="input" className="getAmort-control-label">Date of Loan Disbursal</label><i className="getAmort-bar"></i>
                                                            </div>

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_fed " type="date" required="required" id="getAmort_fed" onChange={this.handleAmortChange.bind(this, "amort_fed")} value={this.state.amort_fields["amort_fed"]} />
                                                                <label htmlFor="input" className="getAmort-control-label">Date of First EMI</label><i className="getAmort-bar"></i>
                                                            </div>

                                                        </div>
                                                        <div className="row" id="formulario">
                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4" id="textAddField">
                                                                <input ref="amort_other" type="number" required="required" id="getAmort_other" min="0" onChange={this.handleAmortChange.bind(this, "amort_other")} value={this.state.amort_fields["amort_other"]} />
                                                                <label htmlFor="input" id="getUpFront" className="getAmort-control-label">Upfront</label><i className="getAmort-bar"></i>
                                                            </div>

                                                            <div className="caption-header mt-4">
                                                                <Button className="btn btn-info btn-xs edit-button" size="xs" onClick={this.toggleBifurcationModal}>
                                                                    <i className="fa fa-plus"></i>
                                                                </Button>
                                                            </div>
                                                        </div>


                                                        <div className="row">
                                                            <div className="getAmort-button-container col-md-12 col-lg-12">
                                                                <p style={{ color: 'red' }}>
                                                                    {this.state.amort_request_msg}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.tenure_Valid ?
                                                                (<p style={{ color: 'red' }}>
                                                                    Enter a valid tenure
                                                                    {this.state.show_amort_schedule_after_parameter_change = ""}
                                                                </p>)
                                                                : this.state.other_Valid ?
                                                                    (<p style={{ color: 'red' }}>
                                                                        Enter a valid Upfront Amount
                                                                        {this.state.show_amort_schedule_after_parameter_change = ""}

                                                                    </p>)
                                                                    : this.state.approved_amount_Valid ?
                                                                        (<p style={{ color: 'red' }}>
                                                                            Enter a valid approved amount
                                                                            {this.state.show_amort_schedule_after_parameter_change = ""}

                                                                        </p>)
                                                                        : this.state.dd_Valid ?
                                                                            (<p style={{ color: 'red' }}>
                                                                                Enter a valid disbursal date
                                                                                {this.state.show_amort_schedule_after_parameter_change = ""}

                                                                            </p>)
                                                                            : this.state.fed_Valid ?
                                                                                (<p style={{ color: 'red' }}>
                                                                                    Enter a valid First EMI date
                                                                                    {this.state.show_amort_schedule_after_parameter_change = ""}

                                                                                </p>)
                                                                                : this.state.roi_Valid ?
                                                                                    (<p style={{ color: 'red' }}>
                                                                                        Enter a valid Rate of Interest value
                                                                                        {this.state.show_amort_schedule_after_parameter_change = ""}

                                                                                    </p>)
                                                                                    : this.state.pf_Valid ?
                                                                                        (<p style={{ color: 'red' }}>
                                                                                            Enter a valid Processing fee value
                                                                                            {this.state.show_amort_schedule_after_parameter_change = ""}

                                                                                        </p>)
                                                                                        :
                                                                                        <div className="row">

                                                                                            <div style={{ color: 'red' }}>{this.state.timeouterror ? this.state.timeouterror : ''}</div>
                                                                                            <div className="submitGetAmortButton">
                                                                                                <button type="button" className="getAmortbutton" id="getAmort_submit" onClick={this.callGetAmort}>
                                                                                                    <span>Get Amortization Schedule</span>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                        }
                                                    </form>
                                                </div>
                                                :
                                                ""
                                        }
                                        {
                                            !this.state.get_lender_disbursed_amount || this.state.tenure_Valid != "" || this.state.other_Valid != "" || this.state.fed_Valid != "" || this.state.dd_Valid != "" || this.state.approved_amount_Valid != "" || this.state.roi_Valid != "" || this.state.pf_Valid != "" || this.state.show_amort_schedule_after_parameter_change == 0 || this.state.amort_request_msg != "" ?
                                                ""
                                                :
                                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                                                    <form role="form" id="getAmortSchedule_form">

                                                        <div className="row">

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_approved_amount" type="number" required="required" id="getAmort_approved_amount" value={this.state.get_lender_disbursed_amount} />
                                                                <label htmlFor="input" className="getAmort-control-label">Disbursed Amount</label><i className="getAmort-bar"></i>
                                                            </div>

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_approved_amount" type="number" required="required" id="getAmort_approved_amount" value={this.state.get_lender_roi} />
                                                                <label htmlFor="input" className="getAmort-control-label">ROI (%)</label><i className="getAmort-bar"></i>
                                                            </div>

                                                        </div>

                                                        <div className="row">
                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_approved_amount" type="number" required="required" id="getAmort_approved_amount" value={this.state.get_gst} />
                                                                <label htmlFor="input" className="getAmort-control-label">GST Charge</label><i className="getAmort-bar"></i>
                                                            </div>

                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_approved_amount" type="number" required="required" id="getAmort_approved_amount" value={this.state.get_lender_disbursed_amount_gst} />
                                                                <label htmlFor="input" className="getAmort-control-label"> Disbursed Amount After GST</label><i className="getAmort-bar"></i>
                                                            </div>
                                                            <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                                <input ref="amort_approved_amount" type="number" required="required" id="getAmort_approved_amount" value={this.state.get_lender_spdc} />
                                                                <label htmlFor="input" className="getAmort-control-label">Total SPDC</label><i className="getAmort-bar"></i>

                                                            </div>

                                                        </div>

                                                        {this.state.get_schedule.map((row, key) => (
                                                            <div key={key} className="row aaaa">
                                                                <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                    <input
                                                                        ref="get_schedule_emi_date"
                                                                        type="date"
                                                                        required="required"
                                                                        id="get_schedule_emi_date"
                                                                        value={row.date}
                                                                    />
                                                                    <label htmlFor="input" className="getAmort-control-label">
                                                                        EMI Date
                                                                    </label>
                                                                    <i className="getAmort-bar" />
                                                                </div>
                                                                <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                    <input
                                                                        ref="get_schedule_emi_amount"
                                                                        type="number"
                                                                        required="required"
                                                                        id="get_schedule_emi_amount"
                                                                        value={get_schedule[key].amount}
                                                                    />
                                                                    <label htmlFor="input" className="getAmort-control-label">
                                                                        EMI Amount
                                                                    </label>
                                                                    <i className="getAmort-bar" />
                                                                </div>
                                                                <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                    <input
                                                                        ref="get_schedule_principal"
                                                                        type="number"
                                                                        required="required"
                                                                        id="get_schedule_principal"
                                                                        name="get_schedule_principal_here"
                                                                        value={get_schedule[key].principal}
                                                                        onChange={this.handleAmortScheduleChange(key, "principal")}
                                                                        onKeyUp={this.handleAmortScheduleChange(key, "principal")}

                                                                    />
                                                                    <label htmlFor="input" className="getAmort-control-label">
                                                                        Principal
                                                                    </label>
                                                                    <i className="getAmort-bar" />
                                                                </div>
                                                                <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                    <input
                                                                        ref="get_schedule_interest"
                                                                        type="number"
                                                                        required="required"
                                                                        id="get_schedule_interest"
                                                                        name="get_schedule_interest_here"
                                                                        value={get_schedule[key].interest}
                                                                        onChange={this.handleAmortScheduleChange(key, "interest")}
                                                                        onKeyUp={this.handleAmortScheduleChange(key, "interest")}

                                                                    />
                                                                    <label htmlFor="input" className="getAmort-control-label">
                                                                        Interest
                                                                    </label>
                                                                    <i className="getAmort-bar" />
                                                                </div>
                                                                <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                    <input
                                                                        ref="get_schedule_starting_balance"
                                                                        type="number"
                                                                        required="required"
                                                                        id="get_schedule_starting_balance"
                                                                        value={get_schedule[key].starting_balance}
                                                                    />
                                                                    <label htmlFor="input" className="getAmort-control-label">
                                                                        Starting Balance
                                                                    </label>
                                                                    <i className="getAmort-bar" />
                                                                </div>
                                                                <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                    <input
                                                                        ref="get_schedule_closing_balance"
                                                                        type="number"
                                                                        required="required"
                                                                        id="get_schedule_closing_balance"
                                                                        value={get_schedule[key].closing_balance}
                                                                    />
                                                                    <label htmlFor="input" className="getAmort-control-label">
                                                                        Closing Balance
                                                                    </label>
                                                                    <i className="getAmort-bar" />
                                                                </div>
                                                            </div>
                                                        ))}
                                                        {
                                                            this.state.loan_approved ?
                                                                ""
                                                                :

                                                                <div className="row">
                                                                    <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                        <input type="number" required="required" id="get_total_principal" value={this.state.total_principal_entered} />
                                                                        <label htmlFor="input" className="getAmort-control-label">
                                                                            Total Principal
                                                                        </label>
                                                                        <i className="getAmort-bar" />
                                                                    </div>

                                                                    <div className="getAmort-form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                                                        <input type="number" required="required" id="get_total_interest" value={this.state.total_interest_entered} />
                                                                        <label htmlFor="input" className="getAmort-control-label">
                                                                            Total Interest
                                                                        </label>
                                                                        <i className="getAmort-bar" />
                                                                    </div>

                                                                </div>
                                                        }

                                                        {
                                                            (this.state.total_principal_verify) ?
                                                                <div>
                                                                    <p>
                                                                        The total principal must be the same.
                                                                    </p>
                                                                </div>

                                                                :
                                                                ""
                                                        }

                                                        {
                                                            this.state.loan_approved || this.state.total_principal_verify != 0 ?
                                                                ""
                                                                :
                                                                <div className="getAmort-button-container col-md-12 col-lg-12">
                                                                    <div>
                                                                        <p>
                                                                            {this.state.total_principal_verify_response}
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p style={{ color: 'red' }}>
                                                                            {this.state.save_amort_error}
                                                                        </p>
                                                                    </div>
                                                                    <div style={{ color: 'red' }}>{this.state.timeouterror ? this.state.timeouterror : ''}</div>
                                                                    <button type="button" className="getAmortbutton" id="setAmortApprove_submit" onClick={this.callSetAmortApprove}>
                                                                        <span>Save & Approve</span>
                                                                    </button>
                                                                </div>
                                                        }

                                                    </form>
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div role="tabpanel" className="tab-pane fade" id="tab3_comments">
                                <Card>
                                    <CardHeader>
                                        <strong>Comments</strong>
                                    </CardHeader>
                                    <CardBlock className="card-body">
                                        <Comments
                                            id={this.state.lead_details.lead_id}
                                            comments={this.state.comments}
                                            getComments={this.getComments} />
                                    </CardBlock>
                                </Card>
                            </div>
                        </div>
                        <Modal
                            isOpen={this.state.cardRegisteredModal}
                            toggle={this.toggleCardRegistered}
                            className='{this.props.className} lg-modal'>
                            <ModalHeader toggle={this.toggleCardRegistered}>
                                Basic Card Details
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup row="row">

                                    <Col className="lines">
                                        <strong>
                                            <Label htmlFor="select">Card Assigned :</Label>
                                        </strong>

                                        <strong>{this.state.card_assigned}</strong>
                                    </Col>

                                    <Col className="lines">
                                        <strong>
                                            <Label htmlFor="select">OTP Verified :</Label>
                                        </strong>

                                        <strong>{this.state.otp_varified}</strong>
                                    </Col>
                                </FormGroup>
                                <FormGroup row="row">
                                    <Col className="lines">
                                        <strong>
                                            <Label htmlFor="select">Card Registered :</Label>
                                        </strong>
                                        <strong>{this.state.card_registered}</strong>
                                    </Col>

                                    <Col className="lines">
                                        <strong>
                                            <Label htmlFor="select">First Pin Reset :</Label>
                                        </strong>

                                        <strong>{this.state.first_pin_reset}</strong>
                                    </Col>

                                </FormGroup>
                                <FormGroup row="row">
                                    <Col className="lines">
                                        <strong>
                                            <Label htmlFor="select">Lock Status :</Label>
                                        </strong>

                                        <strong>{this.state.lock_status}</strong>
                                    </Col>

                                    <Col className="lines">
                                        <strong>
                                            <Label htmlFor="select">Card Loaded :</Label>
                                        </strong>
                                        <strong>{this.state.card_loaded}</strong>
                                    </Col>
                                </FormGroup>

                            </ModalBody>
                            <ModalFooter></ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.cardNotRegisteredModal}
                            toggle={this.toggleNotRegesteredCard}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleNotRegesteredCard}>Target For Card</ModalHeader>
                            <ModalBody>

                                <Form id="cardform" action="" method="post" className="form-horizontal">

                                    <FormGroup row="row">
                                        <Col>
                                            <Label>Target For Card :</Label>&nbsp;&nbsp; {
                                                this.state.lead_details.target_for_card == 1
                                                    ? <label>Yes
                                                        <input
                                                            type="checkbox"
                                                            id="cardCheck"
                                                            checked="checked"
                                                            name="target_for_card"
                                                            onChange={(event) => this.handleUserInputtargetcard(event)} /></label>
                                                    : <label>No
                                                        <input
                                                            type="checkbox"
                                                            id="cardCheck"
                                                            name="target_for_card"
                                                            onChange={(event) => this.handleUserInputtargetcard(event)} /></label>
                                            }
                                            <Input
                                                type="select"
                                                name="address_type"
                                                id="select"
                                                value={this.state.address_type}
                                                onChange={(event) => this.handleUserInputaddresstype(event)}>
                                                <option value="3">Office Address</option>
                                                <option value="1">Comm Address</option>
                                            </Input>
                                            <br /> {
                                                this.state.targetAdded
                                                    ? <FormText color="success">Target Added!</FormText>
                                                    : <div></div>
                                            }

                                            <Col xs="12" sm="12" md="3">
                                                <Button
                                                    outline="outline"
                                                    size="sm"
                                                    color="primary"
                                                    onClick={this.toggleCardNotRegistered}>
                                                    <i className="fa fa-dot-circle-o"></i>
                                                    Save</Button>
                                            </Col>

                                        </Col>

                                    </FormGroup>
                                </Form>
                            </ModalBody>
                        </Modal>
                        <Modal
                            isOpen={this.state.newLoanModal}
                            toggle={this.toggleCreateNewLoan}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleCreateNewLoan}>Add new loan
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup row="row">
                                    <Col md="4">
                                        <Label>Select product type</Label>
                                    </Col>
                                    <Col xs="12" md="8" >
                                        <Input
                                            type="select"
                                            name="selectedProduct"
                                            id="select"
                                            onChange={(event) => this.handleUserInput(event)}>
                                            <option value="0">Please select</option>
                                            {
                                                this
                                                    .state
                                                    .productTypes
                                                    .map(
                                                        (data, key) => <option key={key} value={data.product_code}>{data.product_name}</option>
                                                    )
                                            }
                                        </Input>
                                    </Col>
                                </FormGroup>

                                <FormGroup row="row">
                                    <Col md="4">
                                        <Label htmlFor="text-input">External Reference ID</Label>
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Input
                                            type="text"
                                            id="text-input"
                                            name="bank_loan_ref_id"
                                            placeholder=""
                                            value={this.state.lead_details.bank_loan_ref_id}
                                            onChange={(event) => this.handleUserInput(event)} />
                                        <FormText color="muted">Optional</FormText>
                                    </Col>
                                </FormGroup>

                                <FormGroup row="row">
                                    <Col md="4">
                                        <Label>Loan Amount</Label>
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Slider
                                            min={0}
                                            max={300000}
                                            onChange={(event) => this.handleAmountSlider(event)}
                                            value={this.state.loan_amount}
                                            defaultValue={this.state.selectedProduct === "PRD3"
                                                ? 50000
                                                : 15000}
                                            step={500} />
                                        <FormText className="text-center">
                                            <i className="fa fa-inr"></i>{' ' + this.state.loan_amount}</FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup row="row">
                                    <Col md="4">
                                        <Label>Loan Tenure</Label>
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Slider
                                            min={0}
                                            max={36}
                                            onChange={(event) => this.handleTenureSlider(event)}
                                            value={this.state.loan_tenure}
                                            defaultValue={0}
                                            step={3} />
                                        <FormText className="text-center">{' ' + this.state.loan_tenure + ' Months'}</FormText>
                                    </Col>
                                </FormGroup>

                                <FormGroup row="row">
                                    <FormText color="danger">{this.state.new_serverError}</FormText>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button outline="outline" color="primary" size="sm" onClick={this.addNewLoan}>
                                    <i className="fa fa-dot-circle-o"></i>
                                    Create loan</Button>
                            </ModalFooter>
                        </Modal>
                        {/* Upload Documents */}
                        <Modal
                            isOpen={this.state.uploaddocumentModal}
                            toggle={this.toggleuploaddocument}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleuploaddocument}>Upload Documents
                            </ModalHeader>
                            <ModalBody>

                                {
                                    Object
                                        .keys(this.state.documents)
                                        .map((key) => {
                                            return <div className="doc-w">

                                                <strong className="ucfirst" id="docname_label">{key.replace("_", " ")}</strong>

                                                {
                                                    this
                                                        .state
                                                        .documents[key] != false
                                                        ? <a
                                                            className="inline-block"
                                                            target="_blank"
                                                            href={this
                                                                .state
                                                                .documents[key]}
                                                            name={key}>View</a>
                                                        : <Input
                                                            className="inline-block"
                                                            data-type="doc"
                                                            type="file"
                                                            name={key}
                                                            onChange={(event) => this.handleDocChange(event)} />
                                                }

                                            </div>
                                        })
                                }

                                <hr />
                                <div className="doc-w">
                                    <strong>Other Documents</strong><br />
                                    <div className="margin-bottom-md">
                                        {
                                            this.state.other_documents === []
                                                ? <div></div>
                                                : Object.keys(this.state.other_documents).map((key) => {
                                                    return (
                                                        <span key={key} className="other_doc_w">
                                                            <strong className="ucfirst" id="docname_label">{key.replace("_", " ")}</strong>
                                                            <a
                                                                className="inline-block"
                                                                target="_blank"
                                                                href={this.state.other_documents[key]}>View</a>
                                                        </span>
                                                    )
                                                })
                                        }
                                    </div>
                                    <label>
                                        <b>Add New&nbsp;</b>
                                    </label>
                                    <Input
                                        className="inline-block margin-bottom-sm"
                                        type="text"
                                        name="otherDocumentName"
                                        placeholder="File Name"
                                        title="File Name"
                                        value={this.state.otherDocumentName || ''}
                                        onChange={(event) => this.handleUserInput(event)} />

                                    <Input
                                        className="inline-block"
                                        type="file"
                                        name="document"
                                        data-type="other"
                                        onChange={(event) => this.handleDocChange(event)} />

                                </div>

                            </ModalBody>
                            <ModalFooter>
                            </ModalFooter>
                        </Modal>
                        <Modal
                            isOpen={this.state.pendencyModal}
                            toggle={this.togglependency}
                            className={this.props.className}>
                            <ModalHeader toggle={this.togglependency}>Add Pendency Resolved Comment
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Input
                                        type="textarea"
                                        name="pendency_comment"
                                        className={this.state.pendency_commentValid}
                                        id="comment"
                                        rows="3"
                                        placeholder="Add comment..."
                                        value={this.state.comment || ''}
                                        onChange={(event) => this.handleUserInputpendency(event)}
                                        onBlur={(event) => this.handleUserInput(event)} /> {
                                        this.state.pendency_commentValid === 'is-invalid'
                                            ? <FormText color="danger">Please enter some comment</FormText>
                                            : <div></div>
                                    }
                                    {
                                        this.state.commentAdded
                                            ? <FormText color="success">Comment added!</FormText>
                                            : <div></div>
                                    }
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button outline="outline" color="primary" size="sm" onClick={this.addpendency}>
                                    <i className="fa fa-dot-circle-o"></i>
                                    Save</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal
                            isOpen={this.state.credit_queryModal}
                            toggle={this.togglecredit_query}
                            className={this.props.className}>
                            <ModalHeader toggle={this.togglecredit_query}>Add Credit Query Resolved Comment
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Input
                                        type="textarea"
                                        name="comment"
                                        className={this.state.credit_queryValid}
                                        id="credit_query_comment"
                                        rows="3"
                                        placeholder="Add comment..."
                                        value={this.state.comment || ''}
                                        onChange={(event) => this.handleUserInputcredit(event)}
                                        onBlur={(event) => this.handleUserInput(event)} /> {
                                        this.state.credit_queryValid === 'is-invalid'
                                            ? <FormText color="danger">Please enter some comment</FormText>
                                            : <div></div>
                                    }
                                    {
                                        this.state.commentAdded
                                            ? <FormText color="success">Comment added!</FormText>
                                            : <div></div>
                                    }
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    outline="outline"
                                    color="primary"
                                    size="sm"
                                    onClick={this.addcredit_query}>
                                    <i className="fa fa-dot-circle-o"></i>
                                    Save</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal
                            isOpen={this.state.fossheetModal}
                            toggle={this.fosSheetDetails}
                            className='{this.props.className} lg-modal'>
                            <ModalHeader toggle={this.fosSheetDetails}>FOS Sheet
                            </ModalHeader>
                            <ModalBody>
                                <Form id="fossheetform" action="" method="post" className="form-horizontal">
                                    <FormGroup row="row">
                                        <Col md="6">
                                            <strong>
                                                <label>Approved Amount:</label>
                                            </strong>
                                            <span>&#8377;</span>
                                            <strong>{this.state.approved_amount}</strong>&nbsp;,&nbsp;<br />
                                            <strong>
                                                <label>SPDC:</label>
                                            </strong>
                                            <span>&#8377;</span>
                                            <strong>{this.state.spdc_amount}</strong>&nbsp;,&nbsp;<br />
                                            <strong>
                                                <label>PDC:</label>
                                            </strong>
                                            <span>&#8377;</span>
                                            <strong>{this.state.emi_amount}</strong>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row="row">
                                        <Col md="6">
                                            <label>Mailing Address</label>
                                            <Input
                                                type="text"
                                                name="mailing_address"
                                                disabled="disabled"
                                                value={this.state.customer_address.mailing_address} />
                                        </Col>
                                        <Col md="6">
                                            <label>Permanent Address</label>
                                            <Input
                                                type="text"
                                                name="permant_address"
                                                disabled="disabled"
                                                value={this.state.customer_address.permant_address} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row="row">
                                        <Col md="6">
                                            <label>Office Address</label>
                                            <Input
                                                type="text"
                                                name="office_address"
                                                disabled="disabled"
                                                value={this.state.customer_address.office_address} />
                                        </Col>

                                    </FormGroup>
                                    <FormGroup row="row">
                                        <Col md="6">
                                            <label>Pickup Address:</label>
                                            <Input
                                                type="select"
                                                className={this.state.pickup_addressValid}
                                                name="pickupAddressId"
                                                id="select"
                                                value={this.state.pickupAddressId}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>
                                                <option value="">Select Address</option>
                                                <option value="1">Residence Address</option>
                                                <option value="2">Permanent Address</option>
                                                <option value="3">Office Address</option>
                                            </Input>

                                            {
                                                this.state.pickup_addressValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select address type</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>
                                        <Col md="6">
                                            <label>Pickup Date:</label>

                                            <Input
                                                type="date"
                                                className={this.state.pickup_dateValid}
                                                name="pickup_date"
                                                required="required"
                                                size="12"
                                                pattern="\d{1,2}/\d{1,2}/\d{4}"
                                                value={this.state.latest_pickup.pickup_date}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)} /> {
                                                this.state.pickup_dateValid === 'is-invalid'
                                                    ? <FormText color="danger">Please enter date</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>
                                    </FormGroup>
                                    {
                                        (this.state.latest_pickup !== null || this.state.latest_pickup !== '') ?

                                            (<FormGroup row="row">
                                                <Col md="6">
                                                    <label>Pickup Time From</label>
                                                    <MuiThemeProvider>
                                                        <TimePicker
                                                            format="ampm"
                                                            mode='12h'
                                                            hintText="12hr Format"
                                                            value={this.state.latest_pickup.pickup_time_from}
                                                            onChange={this.handleChangeTimePicker12}
                                                            name="pickup_time_from"
                                                            className={this.state.pickup_time_fromValid} />
                                                    </MuiThemeProvider>
                                                </Col>
                                                <Col md="6">
                                                    <label>Pickup Time To</label>
                                                    <MuiThemeProvider>
                                                        <TimePicker
                                                            mode='12h'
                                                            format="ampm"
                                                            hintText="12hr Format"
                                                            value={this.state.latest_pickup.pickup_time_to}
                                                            onChange={this.handleChangeTimePicker12}
                                                            name="pickup_time_to"
                                                            className={this.state.pickup_time_toValid} />
                                                    </MuiThemeProvider>
                                                </Col>
                                            </FormGroup>)
                                            :
                                            ""
                                    }

                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>Permanent Address Proof:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.papValid} select_option"
                                                id="1"
                                                name="permanent_address_proof"
                                                value={this.state.credit_documents_1.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>

                                                {
                                                    this.state.credit_documents_1
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }

                                            </Input>
                                            {
                                                this.state.papValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select permanent address proof</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>

                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>Current Address Proof:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.capValid} select_option"
                                                name="current_address_proof"
                                                id="14"
                                                value={this.state.credit_documents_14.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>

                                                {
                                                    this
                                                        .state
                                                        .credit_documents_14
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.capValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select current address proof</FormText>
                                                    : <div></div>
                                            }
                                        </Col>
                                        <Col md="6">
                                            <Input
                                                type="text"
                                                className="doc_comment"
                                                id="comment"
                                                name="doc_type_comment"
                                                value={this.state.credit_documents_14.doc_type_comment}
                                                onChange={(event) => this.handleUserInput(event)} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>ID Proof:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.idproofValid} select_option"
                                                name="id_proof"
                                                id="2"
                                                value={this.state.credit_documents_2.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>

                                                {
                                                    this
                                                        .state
                                                        .credit_documents_2
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.idproofValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select ID proof</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">

                                        <Col md="6">
                                            <label>Latest Payslips:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.payslipsValid} select_option"
                                                name="payslips"
                                                id="3"
                                                value={this.state.credit_documents_3.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>

                                                {
                                                    this
                                                        .state
                                                        .credit_documents_3
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.payslipsValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select payslips</FormText>
                                                    : <div></div>
                                            }

                                        </Col>
                                        <Col md="6">
                                            <Input
                                                type="text"
                                                className="doc_comment"
                                                id="comment"
                                                name="doc_type_comment"
                                                value={this.state.credit_documents_3.doc_type_comment}
                                                onChange={(event) => this.handleUserInput(event)} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>Cheques:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.chequesValid} select_option"
                                                name="cheques"
                                                id="4"
                                                value={this.state.credit_documents_4.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>
                                                <option value="0">Select Mode</option>
                                                {
                                                    this
                                                        .state
                                                        .credit_documents_4
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.chequesValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select cheques</FormText>
                                                    : <div></div>
                                            }

                                        </Col>
                                        <Col md="6">
                                            <Input
                                                type="text"
                                                className="doc_comment"
                                                id="comment"
                                                name="doc_type_comment"
                                                value={this.state.credit_documents_4.doc_type_comment}
                                                onChange={(event) => this.handleUserInput(event)} />

                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">

                                        <Col md="6">
                                            <label>Loan Agreement to be signed:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.loanagreementValid} select_option"
                                                name="loan_agreement"
                                                id="5"
                                                value={this.state.credit_documents_5.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>

                                                {
                                                    this
                                                        .state
                                                        .credit_documents_5
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.loanagreementValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select Loan Agreement</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>NACH to be signed:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.nachsignedValid} select_option"
                                                name="nach_signed"
                                                id="6"
                                                value={this.state.credit_documents_6.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>

                                                {
                                                    this
                                                        .state
                                                        .credit_documents_6
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.nachsignedValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select nach signed</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">

                                        <Col md="6">
                                            <label>Office Address Verification:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.officeverifyValid} select_option"
                                                name="office_verification"
                                                id="7"
                                                value={this.state.credit_documents_7.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>

                                                {
                                                    this
                                                        .state
                                                        .credit_documents_7
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.officeverifyValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select office address verification</FormText>
                                                    : <div></div>
                                            }

                                        </Col>
                                        <Col md="6">
                                            <Input
                                                type="text"
                                                className="doc_comment"
                                                id="comment"
                                                name="doc_type_comment"
                                                value={this.state.credit_documents_7.doc_type_comment}
                                                onChange={(event) => this.handleUserInput(event)} />

                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>Photograph:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.photographValid} select_option"
                                                name="photograph"
                                                id="8"
                                                value={this.state.credit_documents_8.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>
                                                {
                                                    this
                                                        .state
                                                        .credit_documents_8
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.photographValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select photograph</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>Office ID Card:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.officeidValid} select_option"
                                                name="office_id_card"
                                                id="9"
                                                value={this.state.credit_documents_9.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>
                                                {
                                                    this
                                                        .state
                                                        .credit_documents_9
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.officeidValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select office id card</FormText>
                                                    : <div></div>
                                            }
                                        </Col>
                                        <Col md="6">
                                            <Input
                                                type="text"
                                                className="doc_comment"
                                                id="comment"
                                                name="doc_type_comment"
                                                value={this.state.credit_documents_9.doc_type_comment}
                                                onChange={(event) => this.handleUserInput(event)} />

                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>DCB Form:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.dcbformValid} select_option"
                                                name="dcb_form"
                                                id="15"
                                                value={this.state.credit_documents_15.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>
                                                {
                                                    this
                                                        .state
                                                        .credit_documents_15
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.dcbformValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select dcb form</FormText>
                                                    : <div></div>
                                            }<br />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="document_row" row="row">
                                        <Col md="6">
                                            <label>Insurance:</label>
                                            <Input
                                                type="select"
                                                className="{this.state.insuranceValid} select_option"
                                                name="insurance"
                                                id="16"
                                                value={this.state.credit_documents_16.document}
                                                onChange={(event) => this.handleUserInputfossheet(event)}
                                                onBlur={(event) => this.handleUserInput(event)}>
                                                {
                                                    this
                                                        .state
                                                        .credit_documents_16
                                                        .map(
                                                            (data, key) => <option key={key} value={data.id}>{data.document}</option>

                                                        )
                                                }
                                            </Input>
                                            {
                                                this.state.insuranceValid === 'is-invalid'
                                                    ? <FormText color="danger">Please select insurance form</FormText>
                                                    : <div></div>
                                            }<br />

                                        </Col>
                                        <Col md="6">
                                            <Input
                                                type="text"
                                                className="doc_comment"
                                                id="comment"
                                                name="doc_type_comment"
                                                value={this.state.credit_documents_16.doc_type_comment}
                                                onChange={(event) => this.handleUserInput(event)} />

                                        </Col>
                                    </FormGroup>

                                    <FormGroup row="row">
                                        <Col md="6">
                                            <label>Pick Up Comment:</label>
                                            <Input
                                                type="text"
                                                name="pickup_comment"
                                                value={this.state.pickup_comment}
                                                onChange={(event) => this.handleUserInput(event)} /> {
                                                this.state.pickup_commentValid === 'is-invalid'
                                                    ? <FormText color="danger">Please fill some comment</FormText>
                                                    : <div></div>
                                            }<br />

                                        </Col>
                                    </FormGroup>

                                    <FormGroup row="row">
                                        <Col>
                                            {
                                                this.state.pickupAdded
                                                    ? <FormText color="success">Pickup added!</FormText>
                                                    : <div></div>
                                            }
                                            <FormText color="danger" id="danger">{this.state.serverError}</FormText>
                                        </Col>
                                    </FormGroup>

                                </Form>
                            </ModalBody>
                            <ModalFooter>
                                {
                                    this.state.lead_details.lead_status == 'Loan Approved'
                                        ? <Button
                                            outline="outline"
                                            color="primary"
                                            size="sm"
                                            onClick={this.submitfossheet}>
                                            <i className="fa fa-dot-circle-o"></i>
                                            Submit</Button>
                                        : <strong>Pickup Already Created!</strong>
                                }
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.messageModal}
                            toggle={this.toggleComment}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleComment}>Add comment
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Input
                                        type="textarea"
                                        name="comment"
                                        className={this.state.commentValid}
                                        id="textarea-input"
                                        rows="3"
                                        placeholder="Add comment..."
                                        value={this.state.comment || ''}
                                        onChange={(event) => this.handleUserInput(event)}
                                        onBlur={(event) => this.handleUserInput(event)} /> {
                                        this.state.commentValid === 'is-invalid'
                                            ? <FormText color="danger">Please enter comment</FormText>
                                            : <div></div>
                                    }
                                    {
                                        this.state.commentAdded
                                            ? <FormText color="success">Comment added!</FormText>
                                            : <div></div>
                                    }
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button outline="outline" color="primary" size="sm" onClick={this.addComment}>
                                    <i className="fa fa-dot-circle-o"></i>
                                    Add comment</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.sendPDFModal}
                            toggle={this.toggleSendPDF}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleSendPDF}>Send Application Form Pdf Email</ModalHeader>
                            <ModalBody>
                                <FormGroup className="sendpdfemail-cont">
                                    <p>Select email type to send document link</p>
                                    <Input
                                        type="select"
                                        name="select_email"
                                        className="col-md"
                                        id="select_email"
                                        value={this.state.select_email}
                                        onChange={(event) => this.handleUserInput(event)}
                                        onBlur={(event) => this.handleUserInput(event)}>
                                        <option value="0">Please select</option>
                                        <option value="1">Personal Email</option>
                                        <option value="2">Professional Email</option>

                                    </Input>


                                </FormGroup>

                            </ModalBody>
                            <ModalFooter>
                                {/* <Button outline="outline" color="primary" size="sm" onClick={this.downloadPDF}>
                                    Download</Button> */}
                                <Button outline="outline" color="primary" size="sm" onClick={this.sendPDF}>
                                    Send Email</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.loanRevisionModal}
                            toggle={this.toggle_loan_revision}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggle_loan_revision}>Add comment
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Input
                                        type="textarea"
                                        name="comment"
                                        className={this.state.commentValid}
                                        id="textarea-input"
                                        rows="3"
                                        placeholder="Add comment..."
                                        value={this.state.comment || ''}
                                        onChange={(event) => this.handleUserInput(event)}
                                        onBlur={(event) => this.handleUserInput(event)} /> {
                                        this.state.commentValid === 'is-invalid'
                                            ? <FormText color="danger">Please enter comment</FormText>
                                            : <div></div>
                                    }
                                    {
                                        this.state.commentAdded
                                            ? <FormText color="success">Comment added!</FormText>
                                            : <div></div>
                                    }
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button outline="outline" color="primary" size="sm" onClick={this.commentcheck}>
                                    <i className="fa fa-dot-circle-o"></i>
                                    Add comment</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.perfiosModal}
                            toggle={this.togglePerfiosModal}
                            className={this.props.className}>
                            <ModalHeader toggle={this.togglePerfiosModal}>Send
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Label id="myInput">
                                        <a href={this.state.e_bank_statement_link} target="blank">{this.state.e_bank_statement_link}</a>
                                    </Label><br />
                                    <Label htmlFor="emails">Send to</Label>
                                    <Input
                                        type="select"
                                        name="emails"
                                        id="emails"
                                        onChange={(event) => this.handleUserInput(event)}>
                                        <option value={this.state.lead_details.email}>{this.state.lead_details.email}</option>
                                        if(this.state.lead_details.office_email){<option value={this.state.lead_details.office_email || '0'}>
                                            {this.state.lead_details.office_email}</option>}
                                    </Input><br />
                                    <label>Can Upload Bank Statement</label>&nbsp;&nbsp; {
                                        this.state.canUploadBankStatement == 1
                                            ? <input
                                                id="myCheck"
                                                type="checkbox"
                                                checked="checked"
                                                name="canUploadBankStatement"
                                                onChange={(event) => this.handleUserInputperfios(event)} />
                                            : <input
                                                id="myCheck"
                                                type="checkbox"
                                                name="canUploadBankStatement"
                                                onChange={(event) => this.handleUserInputperfios(event)} />
                                    }

                                </FormGroup>
                                {
                                    this.state.mail_sent
                                        ? <FormText color="success">Mail sent successfully</FormText>
                                        : <div></div>
                                }
                                {
                                    this.state.mail_unable_to_send
                                        ? <FormText color="danger">{this.state.errorMsg}</FormText>
                                        : <div></div>
                                }
                            </ModalBody>
                            <ModalFooter>
                                {
                                    !this.state.mail_sent
                                        ? <Button color="primary" onClick={this.sendPerfios}>Send</Button>
                                        : <div></div>
                                }
                                <Button color="secondary" onClick={this.togglePerfiosModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.docLinkModal}
                            toggle={this.toggleDocLinkModal}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleDocLinkModal}>Send
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Label className="myInput">{this.state.doc_upload_link}</Label><br />
                                    <Label htmlFor="emails">Send to</Label>
                                    <Input
                                        type="select"
                                        name="emails"
                                        id="emails"
                                        onChange={(event) => this.handleUserInput(event)}>
                                        <option value={this.state.lead_details.email}>{this.state.lead_details.email}</option>
                                        if(this.state.lead_details.office_email){<option value={this.state.lead_details.office_email || '0'}>{this.state.lead_details.office_email}</option>}
                                    </Input>
                                </FormGroup>
                                {
                                    this.state.mail_sent
                                        ? <FormText color="success">Mail sent successfully</FormText>
                                        : <div></div>
                                }
                                {
                                    this.state.mail_unable_to_send
                                        ? <FormText color="danger">{this.state.errorMsg}</FormText>
                                        : <div></div>
                                }
                            </ModalBody>
                            <ModalFooter>
                                {
                                    !this.state.mail_sent
                                        ? <Button color="primary" onClick={this.sendDocLink}>Send</Button>
                                        : <div></div>
                                }
                                <Button color="secondary" onClick={this.toggleDocLinkModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal
                            isOpen={this.state.emailModal}
                            toggle={this.toggleEmailModal}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleEmailModal}>Send
                            </ModalHeader>
                            <ModalBody>
                                <div>Send a verification mail to &nbsp;
                                    <strong>{this.state.lead_details.email}</strong>?</div>
                                {
                                    this.state.mail_sent
                                        ? <FormText color="success">Mail sent successfully</FormText>
                                        : <div></div>
                                }
                                {
                                    this.state.mail_unable_to_send
                                        ? <FormText color="danger">{this.state.errorMsg}</FormText>
                                        : <div></div>
                                }
                            </ModalBody>
                            <ModalFooter>
                                {
                                    !this.state.mail_sent
                                        ? <Button color="primary" onClick={this.sendEmailVerificationLink}>Send</Button>
                                        : <div></div>
                                }
                                <Button color="secondary" onClick={this.toggleEmailModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal
                            isOpen={this.state.ofcEmailModal}
                            toggle={this.toggleOfcEmailModal}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleOfcEmailModal}>Send
                            </ModalHeader>
                            <ModalBody>
                                <div>Send a verification mail to &nbsp;
                                    <strong>{this.state.lead_details.office_email}</strong>?</div>
                                {
                                    this.state.mail_sent
                                        ? <FormText color="success">Mail sent successfully</FormText>
                                        : <div></div>
                                }
                                {
                                    this.state.mail_unable_to_send
                                        ? <FormText color="danger">{this.state.errorMsg}</FormText>
                                        : <div></div>
                                }
                            </ModalBody>
                            <ModalFooter>
                                {
                                    !this.state.mail_sent
                                        ? <Button color="primary" onClick={this.sendEmailVerificationLink}>Send</Button>
                                        : <div></div>
                                }
                                <Button color="secondary" onClick={this.toggleOfcEmailModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.CibilModal}
                            toggle={this.toggleCibilModal}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleCibilModal}>Send for Cibil
                            </ModalHeader>
                            <ModalBody>
                                <FormText>Send for cibil</FormText>
                                {
                                    this.state.mail_sent
                                        ? <FormText color="success">
                                            sent successfully</FormText>
                                        : <div></div>
                                }
                                {
                                    this.state.mail_unable_to_send
                                        ? <FormText color="danger">{this.state.errorMsg}</FormText>
                                        : <div></div>
                                }
                            </ModalBody>
                            <ModalFooter>
                                {
                                    !this.state.mail_sent
                                        ? <Button color="primary" onClick={this.sendForCibil}>Send</Button>
                                        : <div></div>
                                }
                                <Button color="secondary" onClick={this.toggleCibilModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.mobileModal}
                            toggle={this.toggleMobileModal}
                            className={this.props.className}>
                            <ModalHeader toggle={this.toggleMobileModal}>Send
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Label htmlFor="emails">Send verification link to: {this.state.lead_details.mobile_number}
                                        ?</Label>
                                </FormGroup>
                                {
                                    this.state.mail_sent
                                        ? <FormText color="success">SMS sent successfully</FormText>
                                        : <div></div>
                                }
                                {
                                    this.state.mail_unable_to_send
                                        ? <FormText color="danger">{this.state.errorMsg}</FormText>
                                        : <div></div>
                                }

                            </ModalBody>
                            <ModalFooter>
                                {
                                    !this.state.mail_sent
                                        ? <Button color="primary" onClick={this.sendMobileVerificationLink}>Send</Button>
                                        : <div></div>
                                }
                                <Button color="secondary" onClick={this.toggleMobileModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal
                            isOpen={this.state.emiModal}
                            toggle={this.toggleEmiModal}
                            className={'modal-lg ' + this.props.className}>
                            <ModalHeader toggle={this.toggleEmiModal}>EMI Schedule
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup row="row">
                                    <Col md="1"></Col>
                                    <Col md="10">
                                        <ReactTable
                                            data={this.state.emis}
                                            columns={[
                                                {
                                                    accessor: 'emi_id',
                                                    Footer: 'Total:',
                                                    Header: '#',
                                                    maxWidth: 50
                                                }, {
                                                    accessor: 'amount',
                                                    Cell: row => (<span>
                                                        <i className="fa fa-inr"></i>{' ' + row.value}</span>),
                                                    Footer: row => (
                                                        <span>
                                                            <i className="fa fa-inr"></i>{' ' + this.state.loan_details.spdc_amount}</span>
                                                    ),
                                                    Header: 'Amount'
                                                }, {
                                                    accessor: 'date',
                                                    Header: 'EMI Date'
                                                }, {
                                                    accessor: 'interest',
                                                    Cell: row => (<span>
                                                        <i className="fa fa-inr"></i>{' ' + row.value}</span>),
                                                    Header: 'Interest'
                                                }, {
                                                    accessor: 'principle',
                                                    Cell: row => (<span>
                                                        <i className="fa fa-inr"></i>{' ' + row.value}</span>),
                                                    Header: 'Principal'
                                                }, {
                                                    accessor: 'emi_status',
                                                    Cell: row => (
                                                        row.value === 'Tentative'
                                                            ? <span>
                                                                <strong>Future EMI</strong>
                                                            </span>
                                                            : <span>
                                                                <strong>{row.value}</strong>
                                                            </span>
                                                    ),
                                                    Header: 'EMI Status'
                                                }
                                            ]}
                                            defaultPageSize={this.state.total_emis}
                                            showPaginationBottom={false}
                                            defaultSorted={[{
                                                desc: false,
                                                id: 'emis'
                                            }
                                            ]}
                                            className="-striped -highlight" />
                                        <CSVLink data={this.state.emis}
                                            filename={"emi-schedule" + "-" + this.state.lead_details.lead_id + ".csv"}
                                            className="btn btn-primary"
                                        >Download EMI Details
                                        </CSVLink>
                                    </Col>


                                </FormGroup>
                                <FormGroup row="row">
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <Label>Loan Amount:
                                        </Label>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <p className="form-control-static">
                                            <strong>
                                                <i className="fa fa-inr"></i>{' ' + this.state.lead_details.approved_amount}</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <Label>Loan Tenure:
                                        </Label>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <p className="form-control-static">
                                            <strong>{this.state.lead_details.approved_tenure + ' Months'}</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <Label>Loan ROI:
                                        </Label>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <p className="form-control-static">
                                            <strong>{this.state.lead_details.approved_rate + ' %'}</strong>
                                        </p>
                                    </Col>
                                </FormGroup>
                                <FormGroup row="row">
                                    <Col md="2">
                                        <Label>Final Disbursed Amount:
                                        </Label>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <p className="form-control-static">
                                            <strong>
                                                <i className="fa fa-inr"></i>{' ' + this.state.loan_details.disbursal_amount}</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <Label>Loan Disbursal Date:
                                        </Label>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <p className="form-control-static">
                                            <strong>{
                                                ' ' + (
                                                    this.state.loan_disbursal_date
                                                )
                                            }</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" sm="2" md="2" lg="2">
                                        <Label>Loan Processing Fees:
                                        </Label>
                                    </Col>
                                    <Col xs="12" md="2" xs="6" sm="2" md="2" lg="2">
                                        <p className="form-control-static">
                                            <strong>
                                                <i className="fa fa-inr"></i>{
                                                    ' ' + (
                                                        this.state.lead_details.processing_fees
                                                    )
                                                }</strong>
                                        </p>
                                    </Col>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggleEmiModal}>Close</Button>
                            </ModalFooter>
                        </Modal>
                    </Col>

                </Row>
                <Modal
                    isOpen={this.state.loaderActive}
                    toggle={this.toggleLoader}
                    className="loader-modal"
                    backdrop={"static"}>
                    <Loader type="ball-pulse" active="active" />
                </Modal>

                {this.state.loggedOutModal ?
                    this.navigateToLoanDetails() : ''
                }

                {/* <Modal
                    isOpen={this.state.loggedOutModal}
                    toggle={this.logout}
                    className={this.props.className}>
                    <ModalHeader toggle={this.logout}>Session expired</ModalHeader>
                    <ModalBody>
                        Session expired, login again
                </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.logout}>Login</Button>
                    </ModalFooter>
                </Modal> */}

                {/* Add Other Bifurcation value */}
                <Modal isOpen={this.state.bifurcationModal} toggle={this.toggleBifurcationModal} className={this.props.className}>
                    <ModalHeader toggle={this.toggleBifurcationModal}>Add Bifurcation of the Upfront Value </ModalHeader>
                    <ModalBody>
                        <Form>
                            <div id="dynamicInput">
                                {
                                    this.state.inputs.map(input =>
                                        <div className='row mt-1'>
                                            <select name="cars" className="col-lg-5 ml-4 selectDropDownValue"
                                                style={{ background: 'transparent' }}
                                                onChange={this.handleChangeBifurcation}
                                            >
                                                <option value="">Select Value</option>
                                                {otherFeesTypes ?
                                                    otherFeesTypes.map((item) => {
                                                        return (
                                                            <option value={item.id} key={item.id}>{item.type}</option>
                                                        )
                                                    }) : ''
                                                }
                                            </select>
                                            <input type="number" min="0" step="1" placeholder="amount" className="col-lg-5 ml-2 activeValueInput" />
                                        </div>
                                    )
                                }
                                <Button className="btn btn-info btn-xs edit-button mt-1 float-right" style={{ marginRight: '35px' }} size="xs" onClick={() => this.appendInput()}>
                                    <i className="fa fa-plus"></i>
                                </Button>
                            </div>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" size="sm" onClick={this.addOtherNumber}>  Submit</Button>
                    </ModalFooter>
                </Modal>
                {/* Contact History Modal*/}

            </div>

        )
    }
}

export default LoanDetails;







// WEBPACK FOOTER //
// ./src/views/Pages/LoanApplicationDetails/LoanDetails.js